{
  "\"chart.tooltip.substat.phase\"": "Fase {number, select, 0 {1} 1 {2} 2 {3} other {{number}}}",
  "\"chart.tooltip.substat.pv_string\"": "{inverterName}, String {stringNumber}",
  "TEST": "XXX",
  "animation.battery": "Batterij",
  "animation.boiler": "Boiler",
  "animation.consumption": "Huis",
  "animation.electrical_grid": "Net",
  "animation.hp": "Warmtepomp",
  "animation.photovoltaics": "Fotovoltaïsche",
  "animation.wallbox": "Wallbox",
  "animation.wind": "Wind",
  "app_messages.battery_max_soc": "Batterij opladen om maximale SOC in te stellen {maxSoc, number, ::.##}%",
  "app_messages.battery_min_soc": "Batterij ontladen om minimale SOC in te stellen {minSoc, number, ::.##}%",
  "app_messages.body.battery_max_soc": "Het huidige laadniveau van de batterij is {currentSoc, number, ::.##}%.",
  "app_messages.body.battery_min_soc": "Het huidige laadniveau van de batterij is {currentSoc, number, ::.##}%.",
  "app_messages.body.heat_pump_limit_exceeded": "De verbruikslimiet van de warmtepomp is overschreden. De ingestelde limiet is {value, number, ::.##} kW.",
  "app_messages.body.heat_water_limit_exceeded": "De limiet voor warmwaterverbruik is overschreden. De ingestelde limiet is {value, number, ::.##} kW.",
  "app_messages.body.heat_water_max_temperature": "De boiler heeft vandaag al de maximale temperatuur van {maxTemperature, number, ::.##}°C bereikt.",
  "app_messages.body.home_limit_exceeded": "De verbruikslimiet van het huis is overschreden. De ingestelde limiet is {value, number, ::.##} kW.",
  "app_messages.body.inverter_production_mwh": "Uw zonnepaneleninstallatie heeft al geproduceerd {inverterProductionValue, number, ::.##} MWh dit jaar.",
  "app_messages.body.spot_daily_prediction": "Dagelijkse voorspelling: {pvPrediction, select, true {PV-productie: {pvPredictionValue, number, ::.##} kWh. } other {} } {homePrediction, select, true {Huisverbruik: {homePredictionValue, number, ::.##} kWh. } other {} } {batteryPrediction, select, true {Batterijopslag: {batteryPredictionValue, number, ::.##} kWh. } other {} } {hwPrediction, select, true {Boileropslag: {hwPredictionValue, number, ::.##} kWh. } other {} } {hpPrediction, select, true {Warmtepompverbruik: {hpPredictionValue, number, ::.##} kWh. } other {} } {salePrediction, select, true {Resterende energie voor verkoop: {salePredictionValue, number, ::.##} kWh. } other {} }",
  "app_messages.body.spot_daily_summary": "Vandaag op de spotmarkt: {nothingToReport, select, true {Er is niets gepland.} other { {energyForSale, select, true {Het plan is om in de ochtend te verkopen. } other {} } {negativeIntervals, select, false {} other {Negatieve prijs ({negativeIntervals}), wat de overloop zal verminderen. } } {chargingIntervals, select, false {} other {Plan voor batterijladen ({chargingIntervals}). } } {dischargingIntervals, select, false {} other {Plan voor batterij ontladen ({dischargingIntervals}). } } } }",
  "app_messages.body.spot_negative_price_start": "De huidige spotprijs is negatief na aftrek van de commissie. De commissie ingesteld in Infigy is {spotOffsetPrice, number, ::.##} CZK. De huidige spotprijs is {spotNegativePrice, number, ::.##} CZK.",
  "app_messages.body.spot_negative_price_stop": "De huidige spotprijs is niet langer negatief en is {spotNegativePrice, number, ::.##} CZK. De commissie is in Infigy ingesteld op {spotOffsetPrice, number, ::.##} CZK",
  "app_messages.body.wallbox_limit_exceeded": "De oplaadlimiet van het elektrische voertuig is overschreden. De ingestelde limiet is {value, number, ::.##} kW.",
  "app_messages.body.wallbox_stop_charging": "In deze cyclus, {wallboxConsumptionCycleValue, number, ::.##} kWh energie is toegevoegd.",
  "app_messages.button": "Alle berichten verwijderen",
  "app_messages.cancel": "Annuleren",
  "app_messages.confirm": "Alle berichten verwijderen",
  "app_messages.confirm.title": "Wilt u echt alle berichten verwijderen?",
  "app_messages.detail_dialog.close": "Lees",
  "app_messages.heat_pump_limit_exceeded": "De limiet voor het verbruik van de warmtepomp is overschreden",
  "app_messages.heat_water_limit_exceeded": "De limiet voor het warmwaterverbruik is overschreden",
  "app_messages.heat_water_max_temperature": "De maximale temperatuur van het water is bereikt",
  "app_messages.home_limit_exceeded": "De limiet voor het verbruik in huis is overschreden",
  "app_messages.inverter_connected": "De communicatie met de omvormer is tot stand gebracht",
  "app_messages.inverter_disconnected": "De communicatie met de omvormer is verbroken",
  "app_messages.inverter_production_mwh": "Mijlpaal PV-productie",
  "app_messages.load_more": "Meer laden",
  "app_messages.no_messages": "Er zijn hier nog geen meldingen",
  "app_messages.spot_battery_discharge": "Het spotgebaseerde afvoerplan is {spotDischargePlan}",
  "app_messages.spot_daily_prediction": "Dagelijkse voorspelling",
  "app_messages.spot_daily_summary": "Dagelijks overzicht van het spotplan",
  "app_messages.spot_negative_price_start": "De spotprijs is negatief",
  "app_messages.spot_negative_price_stop": "De spotprijs is niet langer negatief",
  "app_messages.spot_start_charging_battery": "Het opladen van de batterij volgens de spotprijs is gestart",
  "app_messages.spot_start_discharging_battery": "Het ontladen van de batterij naar het net volgens de spotprijs is gestart",
  "app_messages.spot_stop_charging_battery": "Het opladen van de batterij volgens de spotprijs is gestopt",
  "app_messages.spot_stop_discharging_battery": "Het ontladen van de batterij naar het net volgens de spotprijs is gestopt",
  "app_messages.test": "Testmelding",
  "app_messages.title": "Alle berichten verwijderen",
  "app_messages.utility_loss_start": "We hebben een stroomstoring gedetecteerd",
  "app_messages.utility_loss_stop": "De stroomstoring is verholpen",
  "app_messages.wallbox_limit_exceeded": "De oplaadlimiet van het elektrische voertuig is overschreden",
  "app_messages.wallbox_start_charging": "Het opladen van de elektrische auto is gestart",
  "app_messages.wallbox_stop_charging": "Het opladen van de elektrische auto is gestopt",
  "app_update_overlay.subtitle": "Even geduld. Na voltooiing van de update herstart de applicatie en wordt het browservenster automatisch vernieuwd",
  "app_update_overlay.title": "Update wordt uitgevoerd",
  "audit_log.error": "Fout tijdens het laden",
  "audit_log.item.author": "Auteur",
  "audit_log.item.date": "Datum",
  "audit_log.item.payload": "Gebeurtenis",
  "audit_log.item.type": "Type",
  "audit_log.title": "Auditlogboek",
  "audit_log_delete.button": "Verwijderen",
  "audit_log_delete.cancel": "Annuleren",
  "audit_log_delete.confirm": "Verwijderen",
  "audit_log_delete.confirm.title": "Wilt u echt alle records in het auditlogboek verwijderen?",
  "audit_log_delete.title": "Auditlogboek verwijderen",
  "azRouters.add": "Nieuwe AZ router toevoegen",
  "azRouters.addButton": "Toevoegen",
  "azRouters.clientId": "Modbus-ID",
  "azRouters.clientId.value": "Modbus-ID: {id}",
  "azRouters.counts": "OK {ok} / Fout {err}",
  "azRouters.empty": "Geen AZ routers geconfigureerd",
  "azRouters.name": "Naam",
  "azRouters.status.error": "Fout",
  "azRouters.status.ok": "OK",
  "azRouters.status.starting": "Starten",
  "azRouters.title": "AZ routers",
  "bez_dodavatele.business_flexibility.title": "Zakelijke flexibiliteit",
  "bez_dodavatele.enabled": "Integratie ingeschakeld",
  "bez_dodavatele.region": "Regiocode",
  "bez_dodavatele.title": "bezDodavatele",
  "boiler.blocking": "Verwarmingsblokkering",
  "boiler.common": "Algemene informatie",
  "boiler.common.phase_3": "Fase 3",
  "boiler.common.power": "Totaal verbruik",
  "boiler.common.power.phase_1": "Fase 1",
  "boiler.common.power.phase_2": "Fase 2",
  "boiler.common.power_today": "Huidig verbruik",
  "boiler.common.power_year": "Jaarlijks verbruik",
  "boiler.common.temperature": "Huidige temperatuur",
  "boiler.common.total": "Totaal verbruik",
  "boiler.settings": "Instellingen",
  "boiler.settings.hdo": "Schakel de reguliere verwarming uit tijdens het hoge tarief",
  "boiler.settings.hdo.subtitle": "Tijden voor het hoge tarief moeten worden ingesteld in de algemene instellingen",
  "boiler.settings.min_soc": "Verwarmingsblok",
  "boiler.settings.min_soc.subtitle": "Batterijladingsniveau waarbij de verwarming wordt geblokkeerd tijdens een stroomstoring",
  "boiler.settings.min_soc_utility": "Verwarmingsblok wanneer het elektriciteitsnet beschikbaar is",
  "boiler.settings.min_soc_utility.subtitle": "Batterijladingsniveau waarbij verwarming wordt geblokkeerd tijdens een stroomstoring",
  "boiler.settings.spot-hi": "Verwarming blokkeren bij hoge spotprijs",
  "boiler.settings.spot-mi": "Verwarming blokkeren bij gemiddelde spotprijs",
  "boiler.settings.temp": "Ingestelde temperatuur",
  "boiler.settings.temp.subtitle": "Een algemene temperatuur die altijd beschikbaar is",
  "boiler.settings.temp_ek": "Temperatuur van fotovoltaïsche energie met behulp van een elektrische boiler",
  "boiler.settings.temp_ek.subtitle": "Voorverwarmingstemperatuur die alleen voor een lage prijs geldt",
  "boiler.settings.temp_spot": "Temperatuur van de spot met elektrische boiler",
  "boiler.settings.temp_spot.subtitle": "Voorverwarmingstemperatuur die alleen voor een lage prijs beschikbaar is",
  "boiler.statistics": "Statistieken",
  "boiler.statisticsTemp": "Boilertemperatuur",
  "boiler.status": "Boilerstand",
  "boiler.status.home": "Boilerstand",
  "boiler_test_trigger.button": "Boiler testen",
  "boiler_test_trigger.button.running": "Test wordt uitgevoerd",
  "boiler_test_trigger.subtitle": "Controleert het juiste aansluiten en de ingestelde kracht van de boiler.",
  "boiler_test_trigger.title": "Boiler testen",
  "boiler_test_wizard.acknowledge.condition": "Voor een juiste boiler test is het noodzakelijk dat de verbruik in het object constant of nul is. Willekeurige schommelingen in het verbruik kunnen de test beïnvloeden. Het huidige verbruik van het object is {power}",
  "boiler_test_wizard.acknowledge.config": "Het huidige {phaseLabel} boiler is ingesteld met een totale kracht van {power}. Deze waarden moeten worden ingesteld volgens het etiket van de boiler.",
  "boiler_test_wizard.acknowledge.confirm": "Bevestigen",
  "boiler_test_wizard.acknowledge.phase1": "1-fasig",
  "boiler_test_wizard.acknowledge.phase3": "3-fasig",
  "boiler_test_wizard.acknowledge.phase_option": "{phase}. fase",
  "boiler_test_wizard.acknowledge.phase_select": "Selecteer de fasen die moeten worden getest. Niet geselecteerde fasen worden overgeslagen.",
  "boiler_test_wizard.acknowledge.phase_select_empty": "Selecteer ten minste één fase.",
  "boiler_test_wizard.acknowledge.start": "Boiler testen",
  "boiler_test_wizard.acknowledge.title": "Informatie voor de test",
  "boiler_test_wizard.result.after": "Verbruik van het object na activatie",
  "boiler_test_wizard.result.before": "Verbruik van het object voor activatie",
  "boiler_test_wizard.result.close": "Sluiten",
  "boiler_test_wizard.result.correct": "Verbruik van de boiler correct",
  "boiler_test_wizard.result.detail_toggle": "Detail test",
  "boiler_test_wizard.result.header": "Testresultaat:",
  "boiler_test_wizard.result.phase_header": "{phase}. fase",
  "boiler_test_wizard.result.real_power": "Geschatte kracht van de boiler",
  "boiler_test_wizard.result.rerun": "Test opnieuw starten",
  "boiler_test_wizard.result.set_power": "Ingestelde kracht",
  "boiler_test_wizard.result.stable": "Meting was stabiel",
  "boiler_test_wizard.result.title": "Testresultaat",
  "boiler_test_wizard.running.activate": "Activatie van de boilerfase",
  "boiler_test_wizard.running.after": "Verbruik van het object is {power}",
  "boiler_test_wizard.running.before": "Verbruik van het object voor de test is {power}",
  "boiler_test_wizard.running.measuring": "Meting wordt uitgevoerd…",
  "boiler_test_wizard.running.phase": "Test de fase {phase}",
  "boiler_test_wizard.running.real_power": "Geschatte kracht van de boiler is {power}",
  "boiler_test_wizard.running.remaining": "Er blijft ongeveer {seconds} seconden over",
  "boiler_test_wizard.running.reset": "Verbruik resetten",
  "boiler_test_wizard.running.result_fail": "Testfase is niet correct",
  "boiler_test_wizard.running.result_ok": "Testfase is correct",
  "boiler_test_wizard.running.stable": "Verbruik was stabiel",
  "boiler_test_wizard.running.title": "Test wordt uitgevoerd",
  "boiler_test_wizard.running.unstable": "Meting was niet stabiel",
  "boiler_test_wizard.title": "Boiler testen",
  "cancel": "Annuleren",
  "chart.range.this_week": "Afgelopen week",
  "chart.range.today": "Laatste 24{nbsp}uur",
  "chart.tooltip.active_condition.title": "Huidige modus",
  "chart.tooltip.active_condition.value.battery": "Batterij",
  "chart.tooltip.active_condition.value.compressor-blocked": "Compressor geblokkeerd, laag batterijniveau",
  "chart.tooltip.active_condition.value.cooling": "Koeling",
  "chart.tooltip.active_condition.value.error": "Fout",
  "chart.tooltip.active_condition.value.heating": "Verwarming",
  "chart.tooltip.active_condition.value.hot-water": "Warmwaterverwarming",
  "chart.tooltip.active_condition.value.inactive": "Inactief",
  "chart.tooltip.active_condition.value.manual": "Handmatig",
  "chart.tooltip.active_condition.value.not-connected": "Kan geen verbinding maken",
  "chart.tooltip.active_condition.value.not-licensed": "Geen licentie",
  "chart.tooltip.active_condition.value.off": "Uit",
  "chart.tooltip.active_condition.value.overflow": "Overloop",
  "chart.tooltip.active_condition.value.pool": "Zwembadverwarming",
  "chart.tooltip.active_condition.value.spot": "Spot",
  "chart.tooltip.active_condition.value.time": "Tijd",
  "chart.tooltip.control_mode.title": "Gecontroleerd door",
  "chart.tooltip.control_mode.value": "{mode, select, photovoltaic {Photovoltaics} net {Grid} spot {Spot} flexibiliteit {Flexibility} fout {Error} other {{mode}} }",
  "chart.tooltip.wallbox_authorization_card_id.title": "RFID-kaart:",
  "charts.error.dialog.title": "Er is een fout opgetreden tijdens het laden van de statistieken",
  "charts.mode.day": "Dag",
  "charts.mode.week": "Week",
  "charts.mode.year": "Jaar",
  "charts.summary.value": "Totaal {value}",
  "close": "Sluiten",
  "cloud_plugs.bat": "Bediening via batterij",
  "cloud_plugs.battery.battery_start": "Inschakelen tijdens het opladen",
  "cloud_plugs.battery.battery_start.subtitle": "Batterij opladen waardoor het stopcontact wordt geactiveerd",
  "cloud_plugs.battery.battery_stop": "Uitschakelen tijdens het opladen",
  "cloud_plugs.battery.battery_stop.subtitle": "Batterij opladen, waardoor het stopcontact wordt uitgeschakeld",
  "cloud_plugs.battery.on": "Actief",
  "cloud_plugs.battery_charged": "Batterij opgeladen",
  "cloud_plugs.condition": "Conditie",
  "cloud_plugs.condition.and": "En",
  "cloud_plugs.condition.or": "Of",
  "cloud_plugs.led_mode.battery.subtitle": "LED actief als de batterij ten minste 95% is opgeladen",
  "cloud_plugs.led_mode.battery.switch.title": "LED wanneer het stopcontact is ingeschakeld",
  "cloud_plugs.led_mode.battery.title": "LED wanneer de batterij is opgeladen",
  "cloud_plugs.led_mode.mode": "{mode, select, unknown {---} off {Uit} switch {Schakelaar} current {Door stroom} other {Onbekend}}",
  "cloud_plugs.led_mode.overflow.subtitle": "LED actief bij stabiele overloop",
  "cloud_plugs.led_mode.overflow.title": "LED wanneer overloop optreedt",
  "cloud_plugs.led_mode.switch.subtitle": "LED actief als de aansluiting is ingeschakeld",
  "cloud_plugs.led_mode.title": "LED-signalering",
  "cloud_plugs.list.id": "ID",
  "cloud_plugs.list.led_mode": "LED-signalering",
  "cloud_plugs.list.online": "Online",
  "cloud_plugs.list.relay": "Relais",
  "cloud_plugs.list.title": "Status",
  "cloud_plugs.overflow": "Bediening via overloop",
  "cloud_plugs.overflow.help": "Het stopcontact inschakelen bij een gedefinieerde overloop naar het net.",
  "cloud_plugs.overflow.on": "Actief",
  "cloud_plugs.overflow.startPower": "Aanzetten bij verbruik uit het net",
  "cloud_plugs.overflow.startPower.help": "Het stopcontact gaat aan als de overloop na een gedefinieerde vertraging op het ingestelde niveau is. Als de waarde op -1500W staat en de aanzetvertraging 5 minuten is, gaat het stopcontact aan wanneer de overloop naar het net minimaal 1500W is gedurende 5 minuten.",
  "cloud_plugs.overflow.startPower.subtitle": "Negatieve waarde is overloop, positieve waarde is verbruik",
  "cloud_plugs.overflow.stopPower": "Uitzetten bij verbruik uit het net",
  "cloud_plugs.overflow.stopPower.help": "Het stopcontact gaat uit als het verbruik na een gedefinieerde vertraging hoger is dan het ingestelde niveau. Als de waarde op 100W staat en de uitzetvertraging 5 minuten is, gaat het stopcontact uit wanneer het verbruik uit het net minimaal 100W is gedurende 5 minuten.",
  "cloud_plugs.overflow.stopPower.subtitle": "Negatieve waarde is overloop, positieve waarde is verbruik",
  "cloud_plugs.pv_power": "Besturing op PV-vermogen",
  "cloud_plugs.pv_power.help": "Het stopcontact inschakelen bij een gedefinieerd PV-vermogen.",
  "cloud_plugs.pv_power.on": "Actief",
  "cloud_plugs.pv_power.startPower": "Aanzetten bij PV-productie",
  "cloud_plugs.pv_power.startPower.help": "Het stopcontact gaat aan als het PV-vermogen groter is dan het ingestelde niveau. Als de waarde op 1000W staat, gaat het stopcontact aan wanneer het PV-vermogen minimaal 1000W is.",
  "cloud_plugs.pv_power.stopPower": "Uitzetten bij PV-productie",
  "cloud_plugs.pv_power.stopPower.help": "Het stopcontact gaat uit als het PV-vermogen lager is dan het ingestelde niveau. Als de waarde op 500W staat, gaat het stopcontact uit wanneer het PV-vermogen minder dan 500W is.",
  "cloud_plugs.time": "Tijdgestuurde bediening",
  "cloud_plugs.time.on": "Actief",
  "cloud_plugs.title": "Aansluitingen",
  "cloud_plugs.turn_off": "Uitschakelen",
  "cloud_plugs.turn_on": "Inschakelen",
  "dark_mode.dark": "Donker",
  "dark_mode.light": "Licht",
  "dark_mode.system": "Systeem",
  "delta_green.battery_max_power_in": "Maximaal batterijvermogen IN (W)",
  "delta_green.battery_max_power_out": "Maximaal batterijvermogen OUT (W)",
  "delta_green.business_flexibility.title": "Zakelijke flexibiliteit",
  "delta_green.connected": "Status",
  "delta_green.enabled": "Integratie ingeschakeld",
  "delta_green.last_messages": "Laatste berichten",
  "delta_green.last_messages.date": "Tijd",
  "delta_green.last_messages.payload": "Bericht",
  "delta_green.last_messages.topic": "Onderwerp",
  "delta_green.pv_orientation": "Fotovoltaïsche oriëntatie",
  "delta_green.title": "Delta Green",
  "des_battery_container.status.error": "Fout",
  "des_battery_container.status.none": "Onbekende status",
  "des_battery_container.status.off": "Uit",
  "des_battery_container.status.run": "Normale modus",
  "des_battery_container.status.sleep": "Slaapmodus",
  "dev.cloud_plugs.mqtt_cloud.connected": "MQTT Cloud-verbindingsstatus",
  "dev.cloud_plugs.title": "Cloud-sockets",
  "dev.inverter_config.connection.lan": "LAN",
  "dev.inverter_config.connection.rs485": "RS485",
  "dev.inverter_config.connection.rs485_hint": "Adres en poort worden van het bord overgenomen ({host}:{port}).",
  "dev.inverter_config.rename_warning": "Als u de sleutel van \"{from}\" naar \"{to}\" hernoemt, raken historische gegevens losgekoppeld — statistieken en opgewekte energie die onder de oorspronkelijke sleutel zijn opgeslagen.",
  "dev.inverter_config.search.open": "Omvormer zoeken",
  "dev.inverter_config.search.title": "Omvormer zoeken",
  "dev.inverter_config.stats.all": "Alles",
  "dev.inverter_config.status.counts": "OK {ok} / Fouten {err}",
  "dev.inverter_config.status.error": "Fout",
  "dev.inverter_config.status.ok": "OK",
  "dev.inverter_config.status.starting": "Starten",
  "dev.inverter_config.title": "Omvormerconfiguratie",
  "dev.link": "Dev",
  "dev_app_messages.test_send": "Testmelding",
  "dev_app_messages.test_send.button": "Verzenden",
  "dev_homepage.app_messages.title": "Meldingen",
  "dev_homepage.title": "Ontwikkelingsmenu",
  "dev_spot.summary.title": "Overzicht modi",
  "dev_spot.title": "Spot (ontwikkeling)",
  "dev_status_log.empty": "Er zijn nog geen gegevens",
  "dev_status_log.error": "Fout bij laden",
  "dev_status_log.title": "Status logboek",
  "dev_status_log.today": "Vandaag",
  "dhcp_host.address": "IP-adres",
  "dhcp_host.create.title": "Nieuwe DHCP-host",
  "dhcp_host.edit.title": "DHCP-host bewerken",
  "dhcp_host.mac": "MAC-adres",
  "dhcp_host.name": "Naam",
  "dhcp_hosts.remove.cancel": "Annuleren",
  "dhcp_hosts.remove.confirm": "Verwijderen",
  "dhcp_hosts.remove.confirm.title": "Wilt u het DHCP-hostadres echt ongedaan maken?",
  "dhcp_leases.ip": "IP-adres",
  "dhcp_leases.mac": "MAC-adres",
  "dhcp_leases.make_static.cancel": "Annuleren",
  "dhcp_leases.make_static.confirm": "Toevoegen",
  "dhcp_leases.make_static.confirm.title": "Wilt u het DHCP-hostadres echt vastleggen?",
  "dhcp_leases.name": "Naam",
  "dhcp_leases.next_renewal": "Volgende verlenging",
  "dhcp_leases.title": "DHCP-leases",
  "ean": "EAN",
  "electree.business_flexibility.title": "Zakelijke flexibiliteit",
  "electree.connected": "Status",
  "electree.enabled": "Integratie ingeschakeld",
  "electree.last_messages": "Laatste berichten",
  "electree.last_messages.date": "Tijd",
  "electree.last_messages.payload": "Bericht",
  "electree.last_messages.topic": "Topic",
  "electree.title": "Electree",
  "electrical_grid.common": "Algemene informatie",
  "electrical_grid.common.overflow": "Totale stroom naar het net",
  "electrical_grid.common.overflow_today": "Overloop naar het net vandaag",
  "electrical_grid.common.overflow_year": "Jaarlijkse overloop naar het net",
  "electrical_grid.common.power": "Totaal verbruik uit het net",
  "electrical_grid.common.power.phase_1": "Fase 1",
  "electrical_grid.common.power.phase_2": "Fase 2",
  "electrical_grid.common.power.phase_3": "Fase 3",
  "electrical_grid.common.power_today": "Huidig verbruik uit het elektriciteitsnet",
  "electrical_grid.common.power_year": "Jaarlijks verbruik van het elektriciteitsnet",
  "electrical_grid.common.total_consumption": "Totaal verbruik van het elektriciteitsnet",
  "electrical_grid.statistics": "Aankoopstatistieken",
  "electrical_grid.statistics_overflow": "Overloopstatistieken",
  "electrical_grid.status": "Status van het elektriciteitsnet",
  "ems.activePower": "Actief vermogen",
  "ems.apparentPower": "Schijnbaar vermogen",
  "ems.details": "Omvormerparameters",
  "ems.inverter": "Omvormer",
  "ems.inverter.mode.backup": "Backup",
  "ems.inverter.mode.feedIn": "Feed-in",
  "ems.inverter.mode.manual": "Manual",
  "ems.inverter.mode.peakShaving": "Peak Shaving",
  "ems.inverter.mode.selfUse": "Self use",
  "ems.inverter.name": "Naam van de inverter",
  "ems.inverter.name.aelio": "X3-AELIO",
  "ems.inverter.name.notConnected": "Niet verbonden",
  "ems.inverter.name.trene100k": "X3-TRENE-100K",
  "ems.inverter.name.trene100ki": "X3-TRENE-100KI",
  "ems.inverter.name.trene125k": "X3-TRENE-125K",
  "ems.inverter.name.unknown": "Onbekend model",
  "ems.mode": "EMS modus",
  "ems.power.index": "Kracht string {index}",
  "ems.power.total": "Totale kracht",
  "ems.powerFactor": "Vermogenfactor",
  "ems.reactivePower": "Reactief vermogen",
  "emsPro.inverter.name.aelio": "X3-AELIO",
  "emsPro.inverter.name.notConnected": "Niet verbonden",
  "emsPro.inverter.name.trene1": "X3-TRENE-1",
  "emsPro.inverter.name.trene100k": "X3-TRENE-100K",
  "emsPro.inverter.name.trene125k": "X3-TRENE-125K",
  "emsPro.inverter.name.x3forth": "X3-FORTH",
  "emsPro.inverter.name.x3forthplus": "X3-FORTH+",
  "emsPro.inverter.name.x3grand": "X3-GRAND",
  "emsPro.inverter.name.x3mgag2": "X3-MGA G2",
  "emsPro.inverter.name.x3prog2": "X3-PRO G2",
  "emsService.basicSettings": "Basisinstellingen",
  "emsService.direction.disabled": "Uitgeschakeld",
  "emsService.direction.read": "Lezen",
  "emsService.direction.write": "Schrijven",
  "emsService.distributionMetrics": "Distributie-opdrachten",
  "emsService.distributionMetrics.diMapping": "Ingangsindeling",
  "emsService.distributionMetrics.enabled": "Lezen van distributie-opdrachten inschakelen",
  "emsService.distributionMetrics.source": "Bron van distributie-opdrachten",
  "emsService.distributionMetrics.source.digitalInputs": "Digitale ingangen",
  "emsService.distributionMetrics.source.plc": "Externe PLC",
  "emsService.enabled": "PLC ingeschakeld",
  "emsService.energyMeters": "Energiemeters",
  "emsService.energyMeters.add": "Nieuwe energiemeter toevoegen",
  "emsService.energyMeters.addButton": "Toevoegen",
  "emsService.energyMeters.azRouter": "AZ router",
  "emsService.energyMeters.azRouter.empty": "Geen AZ routers geconfigureerd",
  "emsService.energyMeters.empty": "Geen energiemeters geconfigureerd",
  "emsService.energyMeters.newMeter": "Naam",
  "emsService.energyMeters.plcMetric": "PLC Metriek",
  "emsService.energyMeters.plcMetric.grid": "Grid",
  "emsService.energyMeters.plcMetric.kgj": "KGJ",
  "emsService.energyMeters.plcMetric.pv": "PV",
  "emsService.energyMeters.shellyId": "Shelly ID",
  "emsService.energyMeters.source": "Bron",
  "emsService.energyMeters.source.azRouter": "AZ router",
  "emsService.energyMeters.source.plc": "PLC",
  "emsService.energyMeters.source.shelly": "Shelly",
  "emsService.gridMetrics": "Netwerkmetrieken",
  "emsService.gridMetrics.enabled": "Grid-metrieken lezen ingeschakeld",
  "emsService.ipAddress": "IP-adres",
  "emsService.kgjMetrics": "KGJ-metrieken",
  "emsService.kgjMetrics.enabled": "KGJ-metrieken lezen ingeschakeld",
  "emsService.metricsDirection": "Richting",
  "emsService.metricsEnabled": "Ingeschakeld",
  "emsService.mqttBroker": "MQTT Broker (Shellies)",
  "emsService.mqttBrokerEnabled": "MQTT Broker ingeschakeld",
  "emsService.mqttBrokerStatus": "MQTT Broker Status",
  "emsService.notAvailable": "EMS-functie is niet beschikbaar",
  "emsService.password": "Wachtwoord",
  "emsService.plcStatus": "PLC-communicatiestatus",
  "emsService.pollInterval": "Interval polling (ms)",
  "emsService.pvMetrics": "PV metriky",
  "emsService.pvMetrics.enabled": "PV-metrieken lezen ingeschakeld",
  "emsService.pvMetrics.meterId": "Energiemeter",
  "emsService.pvMetrics.meterSource": "Gegevensbron",
  "emsService.pvMetrics.meterSource.meter": "Energiemeter",
  "emsService.pvMetrics.meterSource.plc": "PLC",
  "emsService.shelliesList": "Verbonden Shelly apparaten",
  "emsService.username": "Gebruikersnaam",
  "ems_service.link": "EMS-service",
  "ems_service.title": "EMS-service",
  "enerco.ean": "EAN",
  "enerco.enabled": "Integratie ingeschakeld",
  "enerco.prediction.disabled": "Integratie is uitgeschakeld.",
  "enerco.prediction.title": "Voorspelling",
  "enerco.title": "Enerco",
  "energomachine.business_flexibility.title": "Zakelijke flexibiliteit",
  "energomachine.connected": "Status",
  "energomachine.enabled": "Integratie ingeschakeld",
  "energomachine.last_messages": "Laatste berichten",
  "energomachine.last_messages.date": "Tijd",
  "energomachine.last_messages.payload": "Bericht",
  "energomachine.last_messages.topic": "Topic",
  "energomachine.title": "Energomachine",
  "energyMeters.actualPower": "Huidige vermogen",
  "energyMeters.general": "Algemene informatie",
  "energyMeters.meter": "Energiemeter",
  "energyMeters.notConfigured": "Energiemeters zijn niet geconfigureerd. Ga naar het servismenu voor configuratie.",
  "energyMeters.phase1": "Fase 1:",
  "energyMeters.phase2": "Fase 2:",
  "energyMeters.phase3": "Fase 3:",
  "energyMeters.statistics": "Statistieken",
  "energyMeters.todayEnergy": "Huidige verbruik:",
  "energyMeters.totalEnergy": "Totaal verbruik",
  "energyMeters.yearEnergy": "Jaarlijks verbruik:",
  "error": "Fout bij het laden van het rapport.",
  "expertService.HP": "Warmtepomp",
  "expertService.HP.CntComErr": "Foutmeldingsteller",
  "expertService.HP.CntComOk": "Teller voor geldige berichten",
  "expertService.HP.IpAdr": "IP-adres warmtepomp",
  "expertService.HP.maxTempHW": "Maximale temperatuur van warm water voor de warmtepomp",
  "expertService.HP.maxTempHW.subtitle": "Som van flexibele + ingestelde temperatuur",
  "expertService.HW": "Warm water",
  "expertService.HW.HwBatteryPriority": "Batterijladingspercentage waarbij de boiler altijd voorrang heeft",
  "expertService.HW.HwErrEnabled": "Beschikbaarheid van de boiler evalueren",
  "expertService.HW.HwResetErrorTime": "Vertraging voor het resetten van de thermostaatfout",
  "expertService.HW.HwResetErrorTime.subtitle": "Tijd in minuten waarna de thermostaatfout wordt gereset en de verwarming weer start",
  "expertService.HW.LegionellaLastTime": "Laatste keer dat de legionellatemperatuur werd bereikt",
  "expertService.HW.TempId": "ID temperatuursensor",
  "expertService.HW.control": "Type boilerregeling",
  "expertService.HW.control.onoff": "Aan/uit",
  "expertService.HW.control.proportional": "Proportioneel",
  "expertService.HW.hysterezis": "Hysterese warm water",
  "expertService.HW.hysterezis.subtitle": "Hysterese is alleen voor reguliere verwarming",
  "expertService.HW.maxPower": "Maximaal vermogen van de boiler in procenten",
  "expertService.HW.maxPower.subtitle": "Deze instelling is alleen voor proportionele regeling van de boiler en beperkt het maximale vermogen van de brander in procenten.",
  "expertService.HW.offset": "Faseverschuiving [W]",
  "expertService.HW.offset.disabled-overflow": "Verschuiving voor het regelen van de ketel met uitgeschakelde overloop op de fase [W]",
  "expertService.HW.offset.disabled-overflow.subtitle": "Een hoger getal zorgt ervoor dat de ketel meer energie uit het net kan halen wanneer de overloop is",
  "expertService.HW.offset.enabled-overflow": "Verschuiving voor het regelen van de ketel met ingeschakelde overloop op de fase [W]",
  "expertService.HW.offset.enabled-overflow.subtitle": "Hoe hoger het getal, hoe meer energie de ketel uit het net kan halen.",
  "expertService.HW.offset.ongrid": "Offset voor het regelen van de ketel met netstroom [W]",
  "expertService.HW.offset.ongrid.subtitle": "Hoe hoger het getal, hoe meer energie de ketel uit het net kan halen.",
  "expertService.PV": "Fotovoltaïsche",
  "expertService.PV.BatteryPowerPercent": "Laadvermogen van de batterij in procenten",
  "expertService.PV.CntComErr": "Foutmeldingsteller",
  "expertService.PV.CntComOk": "Teller voor geldige meldingen",
  "expertService.PV.ControlMeteringMode": "Regelmethode voor overschot",
  "expertService.PV.ControlMeteringMode.perPhase": "Per fase",
  "expertService.PV.ControlMeteringMode.subtitle": "Regeling per fase berekent het overschot voor de aansturing van apparaten per fase. Gesommeerde regeling werkt met de som van alle fasen.",
  "expertService.PV.ControlMeteringMode.sum": "Gesommeerd",
  "expertService.PV.ExternalPv": "Externe PV aangesloten via SOLAX Meter 2",
  "expertService.PV.ExternalPvSofar": "Externe PV aangesloten via SOFAR Meter 2",
  "expertService.PV.IpAdr": "IP-adres van de omvormer",
  "expertService.PV.MeteringMode": "Meetmethode van het net",
  "expertService.PV.MeteringMode.perPhase": "Per fase",
  "expertService.PV.MeteringMode.subtitle": "Meting per fase telt afname en teruglevering per fase apart. Gesommeerde meting werkt met het saldo van alle fasen.",
  "expertService.PV.MeteringMode.sum": "Gesommeerd",
  "expertService.PV.PowerControlType": "Type vermogenregeling van de net-omvormer",
  "expertService.PV.PowerControlType.fixed": "Vast",
  "expertService.PV.PowerControlType.proportional": "Proportioneel",
  "expertService.PV.StringNumber": "Aantal strings van de omvormer",
  "expertService.PV.StringNumber.subtitle": "Aantal strings van de omvormer weergegeven in de applicatie op het tabblad PV",
  "expertService.PV.Versions": "Versie",
  "expertService.SP": "Spot",
  "expertService.SP.HwCoefficient": "Schattingscoëfficiënt voor boilerenergie",
  "expertService.SP.HwCoefficient.subtitle": "Coëfficiënt van de geschatte energie voor het opladen van de boiler.",
  "expertService.SP.MinDifferencePriceChargeFromGrid": "Minimale spotprijsverschil voor het opladen van netbatterijen",
  "expertService.SP.batteryCoefficient": "Schattingscoëfficiënt voor de oplaadtijd van de batterij",
  "expertService.SP.batteryCoefficient.subtitle": "Coëfficiënt van geschatte tijd voor het opladen van de batterij",
  "expertService.SP.minDifferenceBatterychargeFromGrid": "Minimale geschatte SOC-toename voor het wachten op PV",
  "expertService.SP.minDifferenceBatterychargeFromGrid.subtitle": "Als de geschatte batterijlading onder deze waarde ligt, kan de batterij worden opgeladen via het elektriciteitsnet.",
  "expertService.WB": "Wallbox",
  "expertService.WB.CntComErr": "Foutmeldingsteller",
  "expertService.WB.CntComOk": "Teller voor geldige berichten",
  "expertService.WB.IpAdr": "IP-adres van de wallbox",
  "expertService.general": "Algemene instellingen",
  "expertService.general.largeInstallation": "Grote installatie",
  "expertService.general.largeInstallation.subtitle": "Breidt het bereik van waarden uit voor grote installaties",
  "expertService.password": "Toegang tot service",
  "expertService.password.label": "Wachtwoord",
  "expert_service.app_messages": "Berichten",
  "expert_service.audit_log": "Auditlogboek",
  "expert_service.error_list": "Foutenlijst",
  "expert_service.link": "Expertdienst",
  "expert_service.network": "Netwerk",
  "expert_service.network.button": "Ga naar netwerkinstellingen",
  "expert_service.network.link": "Netwerk",
  "expert_service.reports": "Rapporten",
  "expert_service.stats": "Statistieken",
  "expert_service.title": "Service",
  "expert_service.xyz": "Service",
  "header.title": "Startpagina",
  "header.title.app_messages": "Berichten",
  "header.title.audit_log": "Auditlogboek",
  "header.title.boiler": "Ketel",
  "header.title.cloud_plugs": "Cloud-aansluitingen",
  "header.title.dev": "Netwerkinstellingen",
  "header.title.dev.app_messages": "Meldingen",
  "header.title.dev.az_routers": "AZ routers",
  "header.title.dev.bez_dodavatele": "bezDodavatele",
  "header.title.dev.cloud_plugs": "Cloud-aansluitingen",
  "header.title.dev.delta_green": "Delta Green",
  "header.title.dev.electree": "Electree",
  "header.title.dev.enerco": "Enerco",
  "header.title.dev.energomachine": "Energomachine",
  "header.title.dev.inverter_config": "Omvormerconfiguratie",
  "header.title.dev.mqtt_broker": "MQTT-broker",
  "header.title.dev.mqtt_cloud": "MQTT Cloud",
  "header.title.dev.pre_flexibility": "PRE Flexibiliteit",
  "header.title.dev.scripts": "Scripten",
  "header.title.dev.shellies": "Shellies",
  "header.title.dev.spot": "Spot",
  "header.title.dev.status_log": "Status logboek",
  "header.title.dev.subscriptions": "Abonnementen",
  "header.title.dev_homepage": "Ontwikkelingsmenu",
  "header.title.ems": "EMS",
  "header.title.ems_service": "EMS Service",
  "header.title.energyMeters": "Energiemeters",
  "header.title.expert_service": "Expertservice",
  "header.title.expert_service.network": "Netwerkinstellingen",
  "header.title.grid": "Raster",
  "header.title.heat_pump": "Warmtepomp",
  "header.title.photovoltaics": "Fotovoltaïsche",
  "header.title.plug": "Stopcontact",
  "header.title.relay": "Relais",
  "header.title.reports": "Rapporten",
  "header.title.rfid_cards": "RFID-kaarten",
  "header.title.settings": "Instellingen",
  "header.title.spot": "Spot",
  "header.title.statistics": "Statistieken",
  "header.title.thermostat": "Thermostaat",
  "header.title.wallbox": "Wallbox",
  "header.title.wallbox_list": "Wallboxen",
  "header.title.wind": "Windturbine",
  "heat_pump.HW": "Warmwaterverwarming",
  "heat_pump.HW.actual_temp": "Huidige tanktemperatuur",
  "heat_pump.HW.flexitemp": "Flexibele temperatuur",
  "heat_pump.HW.flexitemp.subtitle": "Temperatuur waarmee het warm water kan worden voorverwarmd",
  "heat_pump.HW.hysteresis": "Hysterese van warmwaterverwarming",
  "heat_pump.HW.on": "Warmwaterverwarming",
  "heat_pump.HW.temp": "Gewenste keteltemperatuur",
  "heat_pump.acond": "Acond",
  "heat_pump.blocked": "Compressorblokkering",
  "heat_pump.blocked.min_soc": "Compressorblokkering",
  "heat_pump.blocked.min_soc_utility": "Compressorblokkering wanneer het elektriciteitsnet beschikbaar is",
  "heat_pump.blocked.subtitle": "Batterijladingsniveau waarbij de compressor wordt geblokkeerd tijdens een stroomstoring",
  "heat_pump.common": "Algemene informatie",
  "heat_pump.common.power": "Totaal verbruik",
  "heat_pump.common.power_today": "Verbruik vandaag",
  "heat_pump.common.power_year": "Jaarlijks verbruik",
  "heat_pump.common.temp": "Huidige temperatuur op de warmtewisselaar",
  "heat_pump.common.total": "Totaal verbruik",
  "heat_pump.ecoone": "Ecoone",
  "heat_pump.flexi": "Energetische flexibiliteit",
  "heat_pump.flexi.flexi_on": "Flexibiliteit modus",
  "heat_pump.flexi.flexi_on.subtitle": "Modus activeert voorverwarming op basis van overtollige energie",
  "heat_pump.flexi.pvstability": "Compressoractiveringspotentieel",
  "heat_pump.flexi_sp": "Spotflexibiliteit",
  "heat_pump.flexi_sp.flexi_increase_on": "Verhoog verbruik",
  "heat_pump.flexi_sp.flexi_increase_on.subtitle": "Modus maakt het mogelijk het verbruik te verhogen bij lage energieprijzen",
  "heat_pump.flexi_sp.flexi_reduce_on": "Uitstel van verbruik",
  "heat_pump.flexi_sp.flexi_reduce_on.subtitle": "Modus maakt het mogelijk om het verbruik uit te stellen bij hoge energieprijzen",
  "heat_pump.nibe": "Nibe",
  "heat_pump.room": "Verwarming",
  "heat_pump.room.equithermalCorrection": "Aanpassing van de verwarmingscurve",
  "heat_pump.room.flexitemp": "Flexibele temperatuur",
  "heat_pump.room.flexitemp.subtitle": "Temperatuur waarmee het huis kan worden voorverwarmd of voorgekoeld",
  "heat_pump.room.on": "Verwarming",
  "heat_pump.room.tem": "Gewenste temperatuur",
  "heat_pump.room.temp": "Huidige kamertemperatuur",
  "heat_pump.room.tempmax": "Gewenste comforttemperatuur",
  "heat_pump.room.tempmin": "Gewenste dempingstemperatuur",
  "heat_pump.room_cool.on": "Koeling",
  "heat_pump.status": "Verwarmingsmodus",
  "heat_pump_wizard.cancel": "Annuleren",
  "heat_pump_wizard.ip_address.alert": "Zorg ervoor dat het IP-adres van de warmtepomp niet verandert (bijvoorbeeld wanneer de warmtepomp een DHCP-adres gebruikt).",
  "heat_pump_wizard.ip_address.input": "IP-adres warmtepomp",
  "heat_pump_wizard.open": "Type warmtepomp instellen",
  "heat_pump_wizard.save": "Opslaan",
  "heat_pump_wizard.title": "Warmtepomp-instellingen",
  "heatpump.statistics": "Statistieken",
  "heatpump.status": "Warmtepompmodus",
  "home.premium.banner.inactive.subtitle": "Infigy Plus biedt meer gedetailleerde grafieken, maandelijkse rapporten, meldingen en nog veel meer.",
  "home.premium.banner.inactive.title": "Wilt u een beter overzicht?",
  "homepage.actual.battery": "Batterijstatus",
  "homepage.actual.boiler": "Boiler",
  "homepage.actual.outdoor_temperature": "Buitentemperatuur",
  "homepage.actual.thermostat": "Thermostaat",
  "homepage.actual.title": "",
  "homepage.animation": "Momenteel",
  "homepage.statuses.title": "Actieve componentmodi",
  "homepage.statuses.tooltip": "Actieve componentmodi",
  "homepage.today.consumed": "Huisverbruik",
  "homepage.today.consumed_WB": "Wallbox",
  "homepage.today.consumed_from_grid": "Verbruik uit het elektriciteitsnet",
  "homepage.today.consumed_hp": "Warmtepomp",
  "homepage.today.consumed_hw": "Warm water",
  "homepage.today.overflow": "Overstroom naar het net",
  "homepage.today.photovoltaics": "Productie van fotovoltaïsche energie",
  "homepage.today.title": "Dagelijkse statistieken",
  "homepage.today.wind": "Windenergieproductie",
  "hp.status.compressor_blocked": "Compressorblokkering, laag batterijniveau",
  "hp.status.cooling": "Koeling",
  "hp.status.heating": "Verwarming",
  "hp.status.hot_water": "Warmwaterverwarming",
  "hp.status.inactive": "Inactief",
  "hp.status.not_connected": "Kan geen verbinding maken",
  "hp.status.not_licensed": "Warmtepomp heeft geen vergunning",
  "hp.status.pool": "Zwembadverwarming",
  "hp.sub_status.consumption_postpone": "wanneer het verbruik wordt verminderd",
  "hp.sub_status.consumption_rise": "wanneer het verbruik wordt verhoogd",
  "hp.sub_status.consumption_with_flexibility": "met flexibiliteit",
  "hp.sub_status.nibe_not_writable": "- kan niet naar NIBE schrijven",
  "hp.sub_status.none": "",
  "initial_wizard.banner.button": "Wizard starten",
  "initial_wizard.banner.hide.confirm": "Wilt u de wizard echt verbergen?",
  "initial_wizard.banner.hide.confirm.description": "U kunt de wizard altijd opnieuw starten in de applicatie-instellingen.",
  "initial_wizard.banner.hide.show_more": "Wizard starten",
  "initial_wizard.banner.hide.yes": "Verbergen",
  "initial_wizard.banner.subtitle": "De wizard helpt u bij het instellen van de basisparameters van uw systeem.",
  "initial_wizard.banner.title": "Voltooi de eerste instellingen",
  "initial_wizard.banner.title.completed": "Eerste instellingen doorlopen",
  "initial_wizard.dialog.finish": "Voltooien",
  "initial_wizard.dialog.next": "Volgende",
  "initial_wizard.dialog.prev": "Terug",
  "initial_wizard.dialog.step": "Stap {current} van {total}",
  "initial_wizard.dialog.title": "Wizard eerste instellingen",
  "initial_wizard.step1.description.active": "Uw toegang tot de service is al actief. U kunt doorgaan naar de volgende stap.",
  "initial_wizard.step1.password_info": "Elk bedrijf heeft een eigen wachtwoord voor het servicemenu. U heeft het wachtwoord ontvangen per e-mail. U kunt het ook altijd bekijken op app.infigy.cz in het partnersgedeelte.",
  "initial_wizard.step1.title": "Toegang tot de service",
  "initial_wizard.step1.welcome": "Welkom bij de eerste instellingen van Infigy. We begeleiden u door de basisconfiguratie van uw systeem. Meer gedetailleerde instellingen vindt u daarna in het servicemenu.",
  "initial_wizard.step10.title": "Wallbox-instellingen",
  "initial_wizard.step11.description": "U heeft de basisinstellingen van Infigy doorlopen. Alle parameters kunnen worden aangepast in het servicemenu.",
  "initial_wizard.step11.service_menu.subtitle": "Instellingen -> helemaal naar beneden -> Toegang tot de service",
  "initial_wizard.step11.service_menu.title": "Servicemenu",
  "initial_wizard.step11.title": "Klaar",
  "initial_wizard.step2.title": "Applicatie-update",
  "initial_wizard.step3.title": "Installatie",
  "initial_wizard.step4.title": "Instelling hoofdschakelaar",
  "initial_wizard.step5.title": "Omvormer aansluiten",
  "initial_wizard.step6.title": "Omvormerparameters",
  "initial_wizard.step7.description": "Als de overloop naar het net wordt beperkt, worden de instellingen naar de omvormer overgebracht. De omvormer zorgt voor de beperking van de overloop. Infigy regelt echter het schrijven en wijzigen van de waarde op basis van de ingevoerde waarde in dit veld. Wijzig daarom niet de overloopbeperking in de omvormer. Controleer bij de eerste installatie de geschreven waarde in de omvormer of deze correct van Infigy naar de omvormer is doorgevoerd.",
  "initial_wizard.step7.title": "Overloopbeperking",
  "initial_wizard.step8.title": "Boilerinstellingen",
  "initial_wizard.step9.title": "Instellingen spot-handel",
  "initial_wizard.step_app_update.description": "Terwijl Infigy onderweg naar u was, hebben we mogelijk nieuwe versies van de applicatie uitgebracht. We raden aan om de eenheid vóór de installatie bij te werken. Als er bijvoorbeeld geen internet beschikbaar is, kunt u de update overslaan en later uitvoeren in het servicemenu of in de portal.",
  "inverter.3mar_plc": "3Mar PLC",
  "inverter.az_router": "AzRouter energiemeter",
  "inverter.control.mode": "Omvormer besturing",
  "inverter.control.mode.chargingFromGrid": "Batterij opladen vanuit net",
  "inverter.control.mode.dischargingToGrid": "Batterij ontladen naar net",
  "inverter.control.mode.noneControl": "Geen besturing",
  "inverter.control.mode.stopCharging": "Stop met opladen",
  "inverter.control.mode.stopDischarging": "Stop met ontladen",
  "inverter.control.mode.stopOverflow": "Stop overstroom",
  "inverter.des_battery_container": "DES - containeropslag",
  "inverter.deye": "Deye LV",
  "inverter.deye_hv": "Deye HV",
  "inverter.fronius": "Fronius SYMO GEN24",
  "inverter.fronius_grid": "Fronius SYMO net",
  "inverter.fronius_verto": "Fronius Verto",
  "inverter.good_we": "GoodWe",
  "inverter.good_we_grid_next": "GoodWe net",
  "inverter.good_we_next": "GoodWe",
  "inverter.goodwe-Grid": "Goodwe-netkoppeling",
  "inverter.goodwe_grid": "Goodwe net",
  "inverter.hes": "HES - batterijopslag",
  "inverter.next": "Meer omvormers",
  "inverter.none": "Geen",
  "inverter.sermatec": "Sermatec",
  "inverter.shellies": "Shellies",
  "inverter.shellies_external": "Shellies extern",
  "inverter.sma_grid": "SMA net",
  "inverter.sofar_solar": "Sofarsolar",
  "inverter.sofar_solar_rs485": "SofarSolar RS485",
  "inverter.solar_edge_grid": "SolarEdge netgekoppeld",
  "inverter.solax": "Solax",
  "inverter.solax-Grid": "Solax-netkoppeling",
  "inverter.solax_ems1000": "Solax EMS1000",
  "inverter.solax_ems1000pro": "Solax EMS1000PRO",
  "inverter.solax_grid": "Solax netgekoppeld",
  "inverter.solax_mega_grid": "Solax MEGA/FORTH netgekoppeld",
  "inverter.solax_mic_grid": "Solax MIC op het net",
  "inverter.solax_next": "SolaxNext",
  "inverter.solinteg": "Solinteg",
  "inverter.victron": "Victron",
  "inverter.wattsonic": "Wattsonic",
  "inverter_wizard.cancel": "Annuleren",
  "inverter_wizard.custom_device_ip_address.alert": "Zorg ervoor dat het IP-adres van de omvormer niet verandert (bijvoorbeeld wanneer de omvormer een DHCP)",
  "inverter_wizard.custom_device_ip_address.input": "IP-adres van de omvormer",
  "inverter_wizard.multiple_inverters.alert": "Neem contact op met de helpdesk voor het instellen van meerdere omvormers. De contactgegevens vindt u in de",
  "inverter_wizard.multiple_inverters.label": "Meerdere omvormers",
  "inverter_wizard.multiple_inverters_or_ems.alert": "Uw systeem bevat al instellingen voor meerdere omvormers of EMS. Deze handleiding is alleen bedoeld voor het instellen van één omvormer. Neem voor wijzigingen in de instellingen van omvormers of EMS contact op met de ondersteuning.",
  "inverter_wizard.nominal_power": "Nominale vermogen van de omvormer",
  "inverter_wizard.nominal_power.helper": "Bereik: 1 tot 100 kW",
  "inverter_wizard.nominal_power.validation": "Voer het nominale vermogen van de omvormer in kW in.",
  "inverter_wizard.open": "Omvormer vinden",
  "inverter_wizard.save": "Opslaan",
  "inverter_wizard.scan": "Omvormer zoeken op het netwerk",
  "inverter_wizard.scanning": "Zoeken naar omvormer op het netwerk",
  "inverter_wizard.submit_error": "Er is een fout opgetreden tijdens het opslaan van de omvormerinstellingen. Probeer het opnieuw.",
  "inverter_wizard.title": "Handleiding voor het aansluiten van de omvormer",
  "layout.disconnected": "Verbinding verbroken",
  "layout.pigpio_init_error_dialog.description": "De Infigy-applicatie is niet correct gestart. Start het apparaat opnieuw op en als het probleem zich blijft voordoen,",
  "layout.pigpio_init_error_dialog.title": "Fout bij het starten van de applicatie",
  "level.thermostat.cooling": "Koeling",
  "level.thermostat.deactivated": "Gedeactiveerd",
  "level.thermostat.heating": "Verwarming",
  "level.thermostat.standby": "Stand-by",
  "level.thermostat.tempErr": "Temperatuurfout",
  "level.thermostatFlexibility.increasePv": "Flexibiliteit gebruikt om temperatuur te verhogen volgens fotovoltaïsche energie",
  "level.thermostatFlexibility.increaseSpot": "Flexibiliteit gebruikt om de temperatuur te verhogen volgens SPOT",
  "level.thermostatFlexibility.normal": "Normaal",
  "level.thermostatFlexibility.reductionSpot": "Flexibiliteit gebruikt om de temperatuur te verlagen op basis van SPOT",
  "mqtt_broker.connected_clients.title": "Klanten",
  "mqtt_broker.enabled": "Ingeschakeld",
  "mqtt_broker.running": "Status",
  "mqtt_broker.title": "MQTT-broker",
  "mqtt_cloud.connected": "Status",
  "mqtt_cloud.connected.offline": "Offline",
  "mqtt_cloud.connected.online": "Online",
  "mqtt_cloud.enabled": "Integratie ingeschakeld",
  "mqtt_cloud.title": "MQTT Cloud",
  "nav.app_messages": "Berichten",
  "nav.home": "Startpagina",
  "nav.logout": "Uitloggen",
  "nav.reports": "Rapporten",
  "nav.sec.boiler": "Boiler",
  "nav.sec.cloud_plugs": "Aansluitingen",
  "nav.sec.ems": "EMS",
  "nav.sec.energyMeters": "Energiemeters",
  "nav.sec.grid": "Netwerk",
  "nav.sec.heatpump": "Warmtepomp",
  "nav.sec.home": "Algemeen",
  "nav.sec.photovoltaics": "Fotovoltaïsche",
  "nav.sec.plug": "Stopcontact",
  "nav.sec.relay": "Relais",
  "nav.sec.spot": "Spot",
  "nav.sec.thermostat": "Thermostaat",
  "nav.sec.wallbox": "Wallbox",
  "nav.sec.wind": "Windturbine",
  "nav.settings": "Instellingen",
  "nav.statistics": "Statistieken",
  "network.ethernet_ports": "Ethernetpoorten",
  "network.ethernet_ports.name": "LAN",
  "network.ethernet_ports.status": "Status",
  "network.ethernet_ports.status.down": "Inactief",
  "network.ethernet_ports.status.up": "Actief",
  "network.scan.error": "Netwerkscan mislukt",
  "network.summary.address": "IP-adres",
  "network.summary.dhcp_host_exists": "Adres vastgelegd op DHCP. Klik om vastlegging ongedaan te maken.",
  "network.summary.error": "Fout bij laden",
  "network.summary.heat_pump": "Warmtepomp",
  "network.summary.inverter": "Omvormer",
  "network.summary.mac": "MAC",
  "network.summary.name": "Naam",
  "network.summary.no_dhcp_host": "Dynamisch adres op DHCP. Klik om te herstellen.",
  "network.summary.not_connected": "Niet verbonden",
  "network.title": "Algemeen",
  "network.wan_address": "WAN-adres",
  "network_wan_edit.dialog.address": "IP-adres",
  "network_wan_edit.dialog.close": "Sluiten",
  "network_wan_edit.dialog.dns": "DNS server",
  "network_wan_edit.dialog.gateway": "Standaardgateway",
  "network_wan_edit.dialog.netmask": "Netmasker",
  "network_wan_edit.dialog.save": "Opslaan",
  "network_wan_edit.dialog.title": "WAN-adres bewerken",
  "nmap.empty": "Niets gevonden",
  "nmap.error": "Scan is mislukt",
  "nmap.host": "Adres",
  "nmap.loading": "Scannen",
  "nmap.output": "Uitvoer",
  "nmap.port": "Poort",
  "nmap.port.help": "Leeg = alleen zoeken naar apparaten",
  "nmap.range.external": "external — klantnetwerk",
  "nmap.range.internal": "internal — Infigy netwerk",
  "nmap.result.address": "IP-adres",
  "nmap.result.mac": "MAC-adres",
  "nmap.result.ports": "Poorten",
  "nmap.result.scanning": "Scannen {target}, dit kan even duren…",
  "nmap.result.target": "Gescand bereik: {target}",
  "nmap.result.vendor": "Fabrikant",
  "nmap.start": "Start",
  "nmap.target": "Adres of bereik",
  "nmap.target.help": "Naamgegeven netwerk of IP / bereik",
  "nmap.title": "Poorten scannen",
  "photovoltaics.battery": "Fotovoltaïsche Accu",
  "photovoltaics.battery.battery_charged": "Accu opladen",
  "photovoltaics.battery.battery_manual_discharge": "Accu handmatig ontladen",
  "photovoltaics.battery.battery_power": "Accu vermogen",
  "photovoltaics.battery.soc_actual": "Gemeten minimale oplaadniveau",
  "photovoltaics.batteryStatus": "BMS-status",
  "photovoltaics.battery_stop": "Accu blokkering",
  "photovoltaics.battery_stop.hdo": "Accu alleen ontladen bij laag tarief (HDO)",
  "photovoltaics.battery_stop.hp": "Accu blokkeren bij warmtepomp gebruik",
  "photovoltaics.battery_stop.hw": "Accu blokkeren bij warmtewater gebruik",
  "photovoltaics.battery_stop.wb": "Accu blokkeren bij wallbox gebruik",
  "photovoltaics.battery_stop.wb.lock_desc": "Wanneer de wallbox modus „Accu opladen“ is ingeschakeld, kan deze blokkering niet worden ingeschakeld. Schakel de blokkering uit en stel een andere wallbox modus in.",
  "photovoltaics.battery_stop.wb.lock_title": "Instelling kan niet worden gewijzigd",
  "photovoltaics.common": "Algemene informatie",
  "photovoltaics.common.battery_charged": "Batterij opladen",
  "photovoltaics.common.battery_manual_charge": "Accu handmatig opladen",
  "photovoltaics.common.battery_manual_charge_soc": "Doel-SOC voor handmatig opladen",
  "photovoltaics.common.battery_manual_charge_subtitle": "Handmatig opladen van de batterij laadt de batterij op tot het doel-SOC, tenzij de gebruiker dit eerder uitschakelt.",
  "photovoltaics.common.battery_manual_discharge": "De batterij handmatig ontladen",
  "photovoltaics.common.battery_manual_discharge_subtitle": "Handmatig ontladen van de batterij ontlaadt de batterij tot het minimale SOC, tenzij de gebruiker dit eerder uitschakelt.",
  "photovoltaics.common.battery_power": "Batterijprestaties",
  "photovoltaics.common.power": "Huidige prestaties",
  "photovoltaics.common.power_today": "Productie van vandaag",
  "photovoltaics.common.power_total": "Totale productie",
  "photovoltaics.common.power_year": "Jaarlijkse productie",
  "photovoltaics.common.string1": "String 1",
  "photovoltaics.common.string2": "String 2",
  "photovoltaics.common.string3": "String 3",
  "photovoltaics.common.string4": "String 4",
  "photovoltaics.common.string5": "String 5",
  "photovoltaics.common.string6": "String 6",
  "photovoltaics.statistics": "Statistieken",
  "photovoltaics.statistics.charge": "Batterij opladen",
  "photovoltaics.statistics.discharge": "Batterij ontladen",
  "photovoltaics.statisticsSoc": "Batterijniveau",
  "photovoltaics.status": "Fotovoltaïsche modus",
  "ping.address": "Adres",
  "ping.output": "Uitgang",
  "ping.start": "Start",
  "ping.stop": "Stop",
  "ping.title": "Ping",
  "plug.bat": "Bediening via batterij",
  "plug.bat.batterySart": "Inschakelen tijdens het opladen",
  "plug.bat.batterySart.help": "Batterijniveau waarbij het stopcontact wordt ingeschakeld. Om het stopcontact in te schakelen, moet het batterijniveau verandert van de ingestelde status naar een hogere status. Als de waarde is ingesteld op 80%, gaat het stopcontact aan wanneer de",
  "plug.bat.batterySart.subtitle": "Batterij opladen waardoor het stopcontact wordt geactiveerd",
  "plug.bat.batteryStop": "Uitschakelen tijdens het opladen”",
  "plug.bat.batteryStop.help": "Batterijniveau waarbij het stopcontact wordt uitgeschakeld. Om het stopcontact uit te schakelen, moet het batterijniveau veranderen van de ingestelde status naar een lagere status. Als de waarde is ingesteld op 80%, schakelt het stopcontact uit wanneer de",
  "plug.bat.batteryStop.subtitle": "De batterij wordt opgeladen, waardoor het stopcontact wordt uitgeschakeld",
  "plug.bat.help": "Inschakelen bij een bepaald batterijniveau. Kan worden gecombineerd met een tijdvoorwaarde. Als aan een van de voorwaarden voor inschakelen is vervuld, wordt het stopcontact ingeschakeld, en als een van de voorwaarden voor uitschakelen",
  "plug.bat.on": "Actief",
  "plug.main": "Algemene informatie",
  "plug.main.consumption": "Huidig verbruik",
  "plug.main.power": "Totaal verbruik",
  "plug.main.power_today": "Huidig verbruik",
  "plug.main.power_year": "Jaarlijks verbruik",
  "plug.main.stat": "Statistieken",
  "plug.overflow": "Controle door overloop",
  "plug.overflow.consumption": "Instelling komt overeen met een apparaat met stroomverbruik",
  "plug.overflow.help": "Het inschakelen van het stopcontact bij een gedefinieerde overstroming in het distributienetwerk. Kan worden gecombineerd met een tijdvoorwaarde. Als aan een van de voorwaarden voor inschakeling is voldaan, wordt het stopcontact ingeschakeld en als aan een van voorwaarden voor uitschakelen is vervuld, wordt de stopcontact uitgeschakeld.",
  "plug.overflow.on": "Actief",
  "plug.overflow.startPower": "Inschakelen bij netverbruik",
  "plug.overflow.startPower.help": "Het stopcontact wordt ingeschakeld als de overloop na een gedefinieerde vertraging op het ingestelde niveau is. Als de waarde is ingesteld op -1500 W is ingesteld en de inschakelvertraging 5 minuten is, wordt de stopcontact ingeschakeld wanneer de overstroom naar hetnetwerk",
  "plug.overflow.startPower.subtitle": "Negatieve waarde is overloop",
  "plug.overflow.stopPower": "Uitschakelen bij netverbruik",
  "plug.overflow.stopPower.help": "Het stopcontact schakelt uit als het verbruik na een bepaalde vertraging hoger is dan het ingestelde niveau. Als de waarde is ingesteld op 100 W en de uitschakelvertraging is 5 minuten, dan schakelt het stopcontact uit wanneer de",
  "plug.overflow.stopPower.subtitle": "Negatieve waarde is overloop, positieve waarde is verbruik",
  "plug.overflow.time": "In- en uitschakelvertraging",
  "plug.overflow.time.help": "Deze parameter wordt gebruikt om de vertraging voor het in- en uitschakelen van het stopcontact bij gedefinieerde terug leveren/verbruiken. Geschikt voor het instellen van prioriteit en het elimineren van frequent schakelen van de stopcontacten.",
  "plug.plug": "Stopcontact",
  "plug.spot": "Regeling op basis van spotprijs",
  "plug.spot.15m.period": "Spotprijsperiode",
  "plug.spot.15m.period.subtitle": "15 minuten intervalen",
  "plug.spot.help": "Inschakelen bij een bepaalde spotprijs. Kan worden gecombineerd met een tijdvoorwaarde. Als aan een van devoorwaarden voor inschakelen is vervuld, wordt de stopcontact ingeschakeld, en als aan een van de voorwaarden voor uitschakelen is",
  "plug.spot.on": "Actief",
  "plug.spot.period": "Spotprijsperiode",
  "plug.spot.period.subtitle": "60 minuten intervalen",
  "plug.spot.price.period": "Tijdsresolutie stopcontact",
  "plug.spot.spotHi": "Activeren bij hoge prijs",
  "plug.spot.spotHi.help": "De socket wordt ingeschakeld als de spotprijs op een hoog niveau staat (zie het tabblad Spot).",
  "plug.spot.spotLow": "Activeren bij een lage prijs",
  "plug.spot.spotLow.help": "De aansluiting wordt ingeschakeld als de spotprijs op een laag niveau ligt (zie het tabblad Spot).",
  "plug.spot.spotMi": "Activeren bij gemiddelde prijs",
  "plug.spot.spotMi.help": "De aansluiting wordt ingeschakeld als de spotprijs op een gemiddeld niveau ligt (zie het tabblad Spot).",
  "plug.spot.spot_above_price": "Activeren bij een hogere prijs dan de ingestelde prijs",
  "plug.spot.spot_above_price.help": "Het stopcontact wordt ingeschakeld als de spotprijs hoger is dan of gelijk is aan de ingestelde spotprijs.",
  "plug.spot.spot_above_price.subtitle": "De aansluiting wordt ingeschakeld als de spotprijs hoger is dan of gelijk is aan de ingestelde spotprijs. Als deze lager is, wordt de",
  "plug.spot.spot_below_price": "Activeren bij een lagere prijs dan de ingestelde prijs",
  "plug.spot.spot_below_price.help": "De socket wordt ingeschakeld als de spotprijs lager is dan of gelijk is aan de ingestelde spotprijs.",
  "plug.spot.spot_below_price.subtitle": "De aansluiting wordt ingeschakeld als de spotprijs lager is dan of gelijk is aan de ingestelde spotprijs. Als deze hoger is, wordt de",
  "plug.spot.spot_neg": "Activeren bij negatieve prijs",
  "plug.spot.spot_neg.help": "De socket wordt ingeschakeld als de spotprijs negatief is (zie het tabblad Spot).",
  "plug.status": "Aansluitmodus",
  "plug.summary.price": "Prijs",
  "plug.summary.price_level": "Prijsniveau",
  "plug.summary.price_level_15m": "Prijsniveau 15m",
  "plug.summary.switch": "Stopcontact inschakelen",
  "plug.summary.time": "Tijd",
  "plug.time": "Regeling op basis van tijd",
  "plug.time.help": "Inschakelen op een bepaald tijdstip. Kan worden gecombineerd met andere voorwaarden, afhankelijk van de batterij (moet zijn geïnstalleerd), spotprijs (moet zijn toegestaan voor spot trading) en overflow (moet zijn toegestaan vooroverloop naar het netwerk). Als aan een van de voorwaarden voor inschakelen is voldaan, wordt het stopcontact ingeschakeld en",
  "plug.time.on": "Actief",
  "plug.time.turn_off": "Uitschakelen op een bepaald tijdstip",
  "plug.time.turn_off.help": "Tijdstip waarop het stopcontact wordt uitgeschakeld. Als u 12:00 uur instelt, wordt het stopcontact precies op het ingestelde tijdstip uitgeschakeld",
  "plug.time.turn_on": "Inschakelen op een bepaald tijdstip",
  "plug.time.turn_on.help": "Tijdstip waarop het stopcontact wordt ingeschakeld. Als u 12:00 uur instelt, wordt het stopcontact precies op het ingestelde tijdstip ingeschakeld",
  "plug.turn_off": "Uitschakelen",
  "plug.turn_on": "Inschakelen",
  "pre_flexibility.business_flexibility.title": "Zakelijke flexibiliteit",
  "pre_flexibility.enabled": "Integratie ingeschakeld",
  "pre_flexibility.title": "PRE Flexibiliteit",
  "premium.banner.active.button": "Abonnement beheren",
  "premium.banner.active.dev_mode": "Abonnement is actief voor ontwikkeling",
  "premium.banner.active.subtitle": "Het Infigy Plus-abonnement is actief. U kunt genieten van alle extra functies in de",
  "premium.banner.active.title": "Abonnement is actief",
  "premium.banner.hide.confirm": "Wilt u de Infigy Plus-banner echt verbergen?”",
  "premium.banner.hide.confirm.description": "U kunt Infigy Plus altijd weer bekijken in de applicatie-instellingen.",
  "premium.banner.hide.later": "Herinner me later",
  "premium.banner.hide.show_more": "Meer informatie",
  "premium.banner.hide.yes": "Verbergen",
  "premium.banner.inactive.button": "Meer informatie",
  "premium.banner.inactive.subtitle": "Til uw energiebeheer naar een hoger niveau. Met Infigy Plus krijgt u nog meer slimme tools -gedetailleerde grafieken, directe meldingen, een verbeterde kalender, gedetailleerde rapporten en nog veel meer.",
  "premium.banner.inactive.title": "Infigy Plus is niet actief",
  "premium.dialog.charts.subtitle": "Krijg de mogelijkheid om de prestaties van individuele strings, het verbruik per fase en",
  "premium.dialog.charts.title": "Gedetailleerde grafieken",
  "premium.dialog.close": "Sluiten",
  "premium.dialog.next.subtitle": "We bereiden een heleboel extra voordelen voor die we geleidelijk aan zullen vrijgeven voor Infigy Plus",
  "premium.dialog.next.title": "Extra voordelen komen er binnenkort aan",
  "premium.dialog.notifications.subtitle": "Ontvang meldingen over negatieve prijzen, opgeladen batterijen en andere gebeurtenissen",
  "premium.dialog.notifications.title": "Meldingen",
  "premium.dialog.other_benefits.subtitle": "We bereiden een heleboel extra voordelen voor die we geleidelijk zullen vrijgeven voor Infigy Plus",
  "premium.dialog.other_benefits.title": "Binnenkort komen er extra voordelen",
  "premium.dialog.reports.subtitle": "Gedetailleerde maandelijkse rapporten die u een duidelijk beeld geven van de productie, het verbruik en het energiegebruik in uw huishouden. Alle belangrijke gegevens staan op één plek - overzichtelijk, duidelijk en aangevuld met grafieken.",
  "premium.dialog.reports.title": "Geavanceerde rapporten",
  "premium.dialog.save": "Abonneer u op Infigy Plus",
  "premium.dialog.schedule.subtitle": "Plan handmatig het opladen of ontladen van de batterij naar behoefte",
  "premium.dialog.schedule.title": "Verbeterde kalender",
  "premium.dialog.spot.subtitle": "Bekijk de geschiedenis van spotprijzen en plannen die Infigy heeft opgesteld in de",
  "premium.dialog.spot.title": "Geschiedenis van spotprijzen",
  "protocol.settings": "Instellingen",
  "protocol.settings.Licence": "Licentie",
  "protocol.settings.distribution": "Licentie",
  "protocol.test": "Apparaattest",
  "protocol.test.internet-connect": "Internetverbinding",
  "protocol.test.inverter-connect": "De omvormer aansluiten",
  "protocol.test.phase_1": "Fase 1-test",
  "protocol.test.phase_2": "Fase 2-test",
  "protocol.test.phase_3": "Fase 3-test",
  "protocol.test.tester": "Apparaat getest door",
  "relay.condition": "Inschakelen voorwaarde",
  "relay.main": "Algemene informatie",
  "relay.name": "Naam relais",
  "relay.spot.diagram": "Besturing op basis van spotprijs",
  "relay.status": "Status",
  "relay.summary.switch": "Relais inschakelen",
  "relay.title": "Relais",
  "report.avg_day_chart.battery_soc": "Laadstatus van de batterij",
  "report.avg_day_chart.consumption": "Verbruik",
  "report.avg_day_chart.grid": "Net",
  "report.avg_day_chart.pv_production": "PV-productie",
  "report.not_generated": "Maak rapport door te klikken",
  "report_test.button": "Test",
  "report_test.date": "Maand (bijv. 2025-09)",
  "report_test.generated": "Rapport gegenereerd",
  "report_test.ok": "OK",
  "report_test.test": "Test",
  "reports.accumulation_increased": "Accumulatie toegenomen",
  "reports.average_water_temperature": "Gemiddelde watertemperatuur",
  "reports.avg_day": "Gemiddelde dag",
  "reports.battery": "Batterij",
  "reports.boiler": "Elektrische boiler",
  "reports.building_consumption": "Verbruik van het gebouw",
  "reports.disclaimer": "De waarden zijn uitsluitend informatief en kunnen afwijken van de officiële metingen van de",
  "reports.energy_estimate": "Energie-inschatting zonder controle",
  "reports.estimated_water_amount": "Geschatte waterhoeveelheid",
  "reports.grid_consumption": "Netverbruik",
  "reports.grid_consumption_hp": "Netverbruik voor warmtepomp",
  "reports.grid_consumption_hw": "Netverbruik voor elektrische boiler",
  "reports.grid_consumption_wallbox": "Netverbruik voor wallbox",
  "reports.heat_pump": "Warmtepomp",
  "reports.household_consumption": "Huishoudelijk verbruik",
  "reports.info": "Algemene informatie",
  "reports.kilometers_driven": "Aantal gereden kilometers",
  "reports.kilometers_driven_from_sun": "Aantal kilometers gereden op zonne-energie",
  "reports.maximum_power": "Maximaal vermogen",
  "reports.monthly_consumption": "Maandelijks verbruik",
  "reports.monthly_production": "Maandelijkse productie",
  "reports.pv": "Fotovoltaïsche installatie",
  "reports.pv_consumption": "PV-verbruik",
  "reports.pv_production": "PV-productie",
  "reports.regenerate_report": "Rapport opnieuw genereren",
  "reports.regenerate_report_confirm_title": "Rapport opnieuw genereren?",
  "reports.rfid_cards": "RFID kaarten",
  "reports.self_consumption": "Zelfverbruik",
  "reports.self_sufficiency": "Zelfvoorziening",
  "reports.self_sufficient_days": "Aantal zelfvoorzienende dagen",
  "reports.share.description": "U kunt de geselecteerde schermafbeelding met anderen delen.",
  "reports.share.share": "Rapport delen",
  "reports.share.title": "Rapport delen",
  "reports.share_report": "Rapport delen",
  "reports.sold_to_distribution_grid": "Verkocht aan het net",
  "reports.stored_energy_from_grid": "Opgeslagen energie uit het net",
  "reports.stored_energy_from_pv": "Opgeslagen energie uit PV",
  "reports.stored_energy_to_battery": "Opgeslagen energie naar batterij",
  "reports.stored_energy_to_boiler": "Opgeslagen energie naar elektrische boiler",
  "reports.stored_energy_to_heat_pump": "Opgeslagen energie naar warmtepomp",
  "reports.stored_energy_to_wallbox": "Opgeslagen energie naar wallbox",
  "reports.total_overflow_to_grid": "Totale overloop naar het net",
  "reports.total_purchase_from_grid": "Totale aankoop van het net",
  "reports.total_with_control": "Totaal met regeling",
  "reports.total_without_control": "Totaal zonder regeling",
  "reports.updated_at": "Gegenereerd op {date}",
  "reports.wallbox": "EV-laadstation (wallbox)",
  "rfid_cards.col.consumption": "Verbruik",
  "rfid_cards.col.created_at": "Toegevoegd",
  "rfid_cards.col.id": "Kaart-ID",
  "rfid_cards.col.name": "Naam",
  "rfid_cards.export": "Exporteer CSV",
  "rfid_cards.from": "Van",
  "rfid_cards.no_cards": "Geen kaarten toegevoegd.",
  "rfid_cards.title": "RFID-kaarten",
  "rfid_cards.to": "Naar",
  "save": "Opslaan",
  "schedules.add": "Plan toevoegen",
  "schedules.add.tooltip": "Toevoegen",
  "schedules.battery_charge": "Batterij opladen",
  "schedules.battery_discharge": "Batterij ontladen",
  "schedules.charging_current": "Oplaadstroom: {chargingCurrent} A",
  "schedules.description": "Plan het handmatig opladen of ontladen van de batterij naar behoefte.",
  "schedules.dialog.title": "Planner",
  "schedules.dialog.title.ev": "EV-opladen plannen",
  "schedules.ev_charging": "EV-opladen",
  "schedules.form.action": "Actie",
  "schedules.form.battery_charge": "Batterij opladen",
  "schedules.form.battery_discharge": "Batterij ontladen",
  "schedules.form.charging-current": "Stellen van de oplaadstroom",
  "schedules.form.charging-current.auto": "Standaard",
  "schedules.form.close": "Sluiten",
  "schedules.form.create": "Aanmaken",
  "schedules.form.duration": "Duur (minuten)",
  "schedules.form.duration.120min": "2 uur",
  "schedules.form.duration.180min": "3 uur",
  "schedules.form.duration.240min": "4 uur",
  "schedules.form.duration.300min": "5 uur",
  "schedules.form.duration.360min": "6 uur",
  "schedules.form.duration.60min": "1 uur",
  "schedules.form.ev_charging": "EV-opladen",
  "schedules.form.frequency": "Frequentie",
  "schedules.form.frequency.daily": "Dagelijks",
  "schedules.form.frequency.monthly": "Maandelijks",
  "schedules.form.frequency.weekly": "Wekelijks",
  "schedules.form.interval.biweekly": "Elke 2 weken",
  "schedules.form.preview.hide": "Voorbeeld verbergen",
  "schedules.form.preview.show": "Geplande voorkomens weergeven",
  "schedules.form.preview.title": "Geplande starts ({count} volgende)",
  "schedules.form.recurring": "Terugkerend",
  "schedules.form.target-soc": "Doel-SOC (optioneel)",
  "schedules.form.until": "Herhalen tot (optioneel)",
  "schedules.form.when": "Wanneer",
  "schedules.loading.error": "Fout bij het laden van schema's",
  "schedules.missed": "Gemist",
  "schedules.no_plans_found": "Geen plannen gevonden.",
  "schedules.processed": "Verwerkt",
  "schedules.remove.confirm": "Wilt u het plan echt verwijderen?",
  "schedules.remove.no": "Annuleren",
  "schedules.remove.recurring.instance": "Alleen dit voorkomen verwijderen",
  "schedules.remove.recurring.series": "Hele reeks verwijderen",
  "schedules.remove.recurring.title": "Terugkerend plan verwijderen",
  "schedules.remove.yes": "Verwijderen",
  "schedules.running": "Wordt uitgevoerd",
  "schedules.scheduled": "Gepland",
  "schedules.show_processed": "Verwerkt weergeven",
  "schedules.target_soc": "Doel SOC: {targetSoc, number, percent}",
  "schedules.title": "Planner",
  "scripts.add": "Aanmaken",
  "scripts.delete": "Verwijderen",
  "scripts.edit": "Bewerken",
  "scripts.loading_error": "Fout bij het laden van scripts",
  "scripts.title": "Scripten",
  "settings.PV.NominalInverterPower": "Nominaal vermogen omvormer",
  "settings.PV.NominalInverterPower.help": "Dit is belangrijk voor de juiste %-berekening van terug leveren voor Solinteg, Wattsonic en Deye.",
  "settings.PV.NominalInverterPower.subtitle": "Nominaal vermogen van de omvormer in kW, belangrijk voor de berekening van het percentage terug leveren naar het netwerk.",
  "settings.PV.StringNumber": "Aantal omvormerstrings",
  "settings.PV.StringNumber.subtitle": "Aantal omvormerstrings weergegeven in het tabblad PV in de applicatie",
  "settings.app_update": "Applicatieversie",
  "settings.app_update.check_button": "Updates controleren",
  "settings.app_update.confirm.cancel": "Annuleren",
  "settings.app_update.confirm.confirm": "Bijwerken",
  "settings.app_update.confirm.description": "De update kan enkele minuten duren. Tijdens de update is de applicatie niet beschikbaar en wordt daarna automatisch herstart.",
  "settings.app_update.confirm.title": "Update uitvoeren?",
  "settings.app_update.error.no_internet": "Controleer de netwerkverbinding",
  "settings.app_update.in_progress": "Update wordt uitgevoerd",
  "settings.app_update.request_button": "Er is een update beschikbaar",
  "settings.app_update.requested": "Update is aangevraagd",
  "settings.app_update.subtitle": "Controleer op nieuwe versies",
  "settings.app_update.title": "Applicatie-update",
  "settings.app_update.up_to_date": "Applicatie is up-to-date",
  "settings.boiler": "Boiler",
  "settings.boiler.3phase": "Driefasige elektrische boiler",
  "settings.boiler.3phase.subtitle": "Sluit een eenfasige elektrische boiler aan op de SSR-uitgang die overeenkomt met de geselecteerde fase.",
  "settings.boiler.HwBatteryPriority": "Als de batterijlading lager is dan deze waarde, is de energieopslagprioriteit volledig beschikbaar voor",
  "settings.boiler.HwBatteryPriority.help": "de batterij. Als de batterijlading hoger is, krijgt de boiler voorrang en begint deze het water te verwarmen met de overtollige energie van de PV - een deel van de energie gaat verder naar de batterij om te worden",
  "settings.boiler.capacity": "Boilerinhoud",
  "settings.boiler.capacity_sub": "Alleen vereist voor spot trading",
  "settings.boiler.enabled": "Geïnstalleerde elektrische boiler",
  "settings.boiler.hysterezis": "Boilerhysterese",
  "settings.boiler.hysterezis.subtitle": "Hysterese is alleen voor reguliere verwarming",
  "settings.boiler.nominal": "Nominaal vermogen",
  "settings.boiler.nominal.subtitle": "Nominaal vermogen voor 1 fase van de elektrische boiler",
  "settings.boiler.phase": "Boilerfase",
  "settings.boiler.phase.subtitle": "L1 = SSR-uitgang 1, L2 = SSR-uitgang 2, L3 = SSR-uitgang 3.",
  "settings.boiler.prio": "Batterijprioriteit",
  "settings.boiler.prio.subtitle": "Als deze optie is ingeschakeld, wordt eerst de batterij opgeladen en daarna de boiler",
  "settings.boiler.shellies": "Boiler wordt aangestuurd via Shelly",
  "settings.boiler.temp_enabled": "Temperatuursensor geïnstalleerd",
  "settings.boiler.temp_enabled.subtitle": "De boiler kan alleen worden gebruikt voor overschotten zonder sensor",
  "settings.device": "Apparaat",
  "settings.device.SN": "Serienummer",
  "settings.device.id": "Apparaat-ID",
  "settings.device.license": "Apparaatlicentie",
  "settings.docs": "Handleidingen en ander materiaal",
  "settings.docs.service_settings_inverter.button": "Ga naar wiki",
  "settings.docs.service_settings_inverter.subtitle": "Handleidingen, procedures en andere informatie",
  "settings.docs.service_settings_inverter.title": "Handleiding voor het aansluiten van de omvormer",
  "settings.docs.tech_wiki.button": "Ga naar wiki",
  "settings.docs.tech_wiki.subtitle": "Handleidingen, procedures en andere informatie",
  "settings.docs.tech_wiki.title": "Technische wiki",
  "settings.docs.user_wiki.button": "Ga naar wiki",
  "settings.docs.user_wiki.subtitle": "Handleidingen, procedures en andere informatie",
  "settings.docs.user_wiki.title": "Gebruikerswiki",
  "settings.hdo": "Instelling van HDO tijden",
  "settings.hdo.help": "Hieronder kunt u de tijden van het lage tarief instellen.",
  "settings.hdo.on1": "Tijd 1",
  "settings.hdo.on2": "Tijd 2",
  "settings.hdo.on3": "Tijd 3",
  "settings.hdo.on4": "Tijd 4",
  "settings.hdo.on5": "Tijd 5",
  "settings.hdo.on6": "Tijd 6",
  "settings.hdo.regular": "Normale werkdag",
  "settings.hdo.start": "Start",
  "settings.hdo.stop": "Stop",
  "settings.hdo.type": "Tijden definiëren voor",
  "settings.hdo.weekend": "Weekend HDO-tijden",
  "settings.heatpump": "Installatie",
  "settings.heatpump.HpBatteryPriority": "Percentage van de batterijlading waarbij de warmtepomp begint met verwarmen",
  "settings.heatpump.HpBatteryPriority.help": "Als de batterijlading lager is dan deze waarde, is de energieaccumulatieprioriteit volledig beschikbaar voor de batterij. Als de batterijlading hoger is, krijgt de warmtepomp voorrang en begint deze te verwarmenhet water verwarmen met de overtollige energie van de PV - een deel van de energie gaat verder naar de batterij om te worden",
  "settings.heatpump.enabled": "Warmtepomp geïnstalleerd",
  "settings.heatpump.flexiAN": "Flexibiliteit van de accumulatietank",
  "settings.heatpump.flexiCool": "Flexibiliteit van de koeling",
  "settings.heatpump.flexiHw": "Flexibiliteit van warm water",
  "settings.heatpump.flexiRoom": "Flexibiliteit van de ruimte",
  "settings.heatpump.hp_type": "Type warmtepomp",
  "settings.heatpump.nominal": "Nominaal ingangsvermogen",
  "settings.heatpump.nominal1": "Nominaal ingangsvermogen",
  "settings.heatpump.priority": "De warmtepomp heeft een hogere prioriteit dan de batterij",
  "settings.heatpump.priority-wb": "Warmtepomp heeft een hogere prioriteit dan de wallbox",
  "settings.heatwatter": "Boiler",
  "settings.heatwatter.legionella": "Legionella",
  "settings.heatwatter.legionella_temp": "Saneringstemperatuur",
  "settings.heatwatter.legionella_temp.subtitle": "Temperatuur waartoe de boiler minstens eens per 14 dagen moet worden verwarmd",
  "settings.inverter_communication_status": "Communicatie met omvormer",
  "settings.inverter_communication_status.not_ok": "Niet verbonden,{br}verbinding wordt gemaakt...",
  "settings.inverter_communication_status.ok": "Communicatie verbonden{br}({count} metingen)",
  "settings.inverter_communication_status.subtitle": "Het tot stand brengen van de verbinding kan enkele tientallen seconden tot een paar minuten duren",
  "settings.notification": "Meldingen",
  "settings.notification.application_settings": "Meldingen - parameters",
  "settings.notification.battery_max_soc": "Maximale SOC-batterij",
  "settings.notification.battery_max_soc.subtitle": "Er wordt een melding gegenereerd wanneer de maximale SOC van de batterij is bereikt. De melding wordt slechts één keer per dag gegenereerd.",
  "settings.notification.battery_max_soc_value": "Maximale SOC-batterij voor meldingen",
  "settings.notification.battery_max_soc_value.subtitle": "Stel de SOC van de batterij in waarbij een melding wordt gegenereerd.",
  "settings.notification.battery_min_soc": "Minimale SOC-batterij",
  "settings.notification.battery_min_soc.subtitle": "Er wordt een melding gegenereerd wanneer de SOC van de batterij daalt tot de ingestelde minimumwaarde. Er wordt slechts één keer per dag een melding gegenereerd.",
  "settings.notification.battery_min_soc_value": "Minimale SOC-batterij voor meldingen",
  "settings.notification.battery_min_soc_value.subtitle": "Stel de SOC van de batterij in waarbij een melding wordt gegenereerd.",
  "settings.notification.daily_prediction.subtitle": "Er wordt elke dag om 8:00 uur een melding gegenereerd",
  "settings.notification.description": "Toestemming om meldingen te genereren die in de applicatie worden gegenereerd",
  "settings.notification.heat_pump_limit_exceeded": "Overschrijding van de limiet voor het verbruik van de warmtepomp",
  "settings.notification.heat_pump_limit_exceeded.subtitle": "Er wordt een melding gegenereerd wanneer de limiet van het warmtepompverbruik wordt overschreden",
  "settings.notification.heat_pump_limit_value": "Dagelijkse limiet van het warmtepompverbruik voor meldingen",
  "settings.notification.heat_pump_limit_value.subtitle": "Stel de limiet van het warmtepompverbruik in waarbij een melding wordt gegenereerd.",
  "settings.notification.heat_water_limit_exceeded": "Overschrijding van de limiet voor verwarmingswater",
  "settings.notification.heat_water_limit_exceeded.subtitle": "Er wordt een melding gegenereerd wanneer de limiet voor verwarmingswater wordt overschreden",
  "settings.notification.heat_water_limit_value": "Dagelijkse limiet voor het verwarmen van water voor meldingen",
  "settings.notification.heat_water_limit_value.subtitle": "Stel de limiet in voor het verwarmen van water, waarbij een melding wordt gegenereerd.",
  "settings.notification.heat_water_max_temperature": "De maximale temperatuur van het water is bereikt",
  "settings.notification.heat_water_max_temperature.subtitle": "Er wordt een melding gegenereerd wanneer de maximale temperatuur van het water in de boiler van PV",
  "settings.notification.home_consumption_limit_exceeded": "Overschrijding van de limiet voor thuisverbruik",
  "settings.notification.home_consumption_limit_exceeded.subtitle": "Er wordt een melding gegenereerd wanneer de limiet voor thuisverbruik wordt overschreden",
  "settings.notification.home_consumption_limit_value": "Dagelijkse limiet van het huishoudelijk verbruik voor meldingen",
  "settings.notification.home_consumption_limit_value.subtitle": "Stel de limiet voor het huishoudelijk verbruik in, waarbij een melding wordt gegenereerd.",
  "settings.notification.iverter_disconnected": "De communicatie met de omvormer is verbroken",
  "settings.notification.iverter_disconnected.subtitle": "Er wordt een melding gegenereerd aan het begin en einde van het communicatieverlies met de",
  "settings.notification.negative_spot": "Negatieve prijs op de spotmarkt",
  "settings.notification.negative_spot.subtitle": "Er wordt een melding gegenereerd aan het begin en einde van de negatieve prijs op de spotmarkt",
  "settings.notification.pv_production_mwh": "Mijlpaal in de productie van fotovoltaïsche energie",
  "settings.notification.pv_production_mwh.subtitle": "Er wordt een melding gegenereerd als de PV in het betreffende jaar MWh aan energie opwekt",
  "settings.notification.spot_charging_battery": "Start en stop het opladen van de batterij op basis van de spotprijs",
  "settings.notification.spot_charging_battery.subtitle": "Er wordt een melding gegenereerd aan het begin en einde van het opladen van de batterij op basis van de",
  "settings.notification.spot_daily_prediction": "Dagelijkse voorspelling",
  "settings.notification.spot_daily_summary": "Dagelijks overzicht van het spotplan",
  "settings.notification.spot_daily_summary.subtitle": "Er wordt elke dag om 8:00 uur een melding gegenereerd.",
  "settings.notification.spot_discharging_battery": "Start en stop het ontladen van de batterij naar het net op basis van de spotprijs",
  "settings.notification.spot_discharging_battery.subtitle": "Er wordt een melding gegenereerd aan het begin en einde van het ontladen van de batterij naar het net",
  "settings.notification.utility_loss": "Stroomuitval",
  "settings.notification.utility_loss.subtitle": "Er wordt een melding gegenereerd aan het begin en einde van de stroomuitval",
  "settings.notification.wallbox_charging_start_stop": "Start en stop het opladen van het elektrische voertuig.",
  "settings.notification.wallbox_charging_start_stop.subtitle": "Er wordt een melding gegenereerd aan het begin en einde van het opladen van de elektrische auto",
  "settings.notification.wallbox_limit_exceeded": "Overschrijding van de limiet voor het opladen van de elektrische auto",
  "settings.notification.wallbox_limit_exceeded.subtitle": "Er wordt een melding gegenereerd wanneer de limiet voor het opladen van het elektrische voertuig wordt overschreden",
  "settings.notification.wallbox_limit_value": "Dagelijkse limiet voor het opladen van de elektrische auto voor meldingen",
  "settings.notification.wallbox_limit_value.subtitle": "Stel de limiet voor het opladen van de elektrische auto in, waarbij een melding wordt gegenereerd.",
  "settings.notification.webapp.subtitle": "U kunt meldingen van Infigy ontvangen via de webapplicatie.",
  "settings.notification.webapp.title": "Webapplicatie",
  "settings.other": "Overige",
  "settings.other.dark_mode": "Donker",
  "settings.other.languate": "Taal",
  "settings.other.overflow_fronius": "De maximale overstroom naar het netwerk wordt beperkt aan de kant van de Fronius-omvormer.",
  "settings.other.overflow_fronius_subtitle": "Deze waarde wordt ingesteld door de distributeur. Overschrijding van deze waarde kan leiden tot financiële sancties van de",
  "settings.other.overflow_settings": "Overstroomwaarde instellen",
  "settings.other.overflow_settings.help": "Dit is een door de service ingestelde waarde voor de maximale overstroom. Deze waarde wordt ingesteld door de distributeur. Overschrijdingdeze waarde kan leiden tot financiële sancties van de distributeur.",
  "settings.other.readability_mode": "Lettergrootte",
  "settings.photovoltaics": "Fotovoltaïsche",
  "settings.photovoltaics.backup_enabled": "Back-up ingeschakeld",
  "settings.photovoltaics.backup_enabled.subtitle": "Informatie over de back-upmodus van de omvormer.",
  "settings.photovoltaics.batterychargingpower": "Laadvermogen van de accu",
  "settings.photovoltaics.batterychargingpower_sub": "Vermogen voor handmatig opladen van de batterij en spotopladen vanuit het elektriciteitsnet",
  "settings.photovoltaics.batterydischargingpower": "Batterijontladingsvermogen",
  "settings.photovoltaics.batterydischargingpower_sub": "Vermogen voor het spotontladen van de batterij naar het elektriciteitsnet",
  "settings.photovoltaics.batteryenabled": "Geïnstalleerde batterij",
  "settings.photovoltaics.batterynominal": "Nominale batterijcapaciteit",
  "settings.photovoltaics.batterynominal_sub": "Alleen vereist voor spotverhandeling",
  "settings.photovoltaics.enabled": "Geïnstalleerde fotovoltaïsche installatie",
  "settings.photovoltaics.gridchargeenabled": "Laden van de batterij vanaf het distributienet ingeschakeld",
  "settings.photovoltaics.inverters-adjust-power": "Huidig vermogen omvormer",
  "settings.photovoltaics.inverters-nominal": "Nominaal vermogen van regelbare omvormers",
  "settings.photovoltaics.nominal": "Nominaal vermogen",
  "settings.photovoltaics.overflow": "Onbeperkte netoverloop",
  "settings.photovoltaics.overflow.value": "Overstroombeperking",
  "settings.photovoltaics.overflow.value.help": "Waarde van de maximale overstroom naar het net. Deze waarde wordt naar de omvormer geschreven. Wijzig deze waarde niet deze waarde in de omvormer niet wijzigen. De overstroombeperking wordt geregeld door Infigy. Controleer de ingestelde",
  "settings.photovoltaics.overflow_fronius.value.help": "Waarde van de maximale overstroom naar het netwerk aan de kant van de Fronius-omvormer. Deze wordt gebruikt als informatie voor Infigy om terug leveren correct te visualiseren.",
  "settings.photovoltaics.settings": "Batterij",
  "settings.photovoltaics.settings.soc_actual": "Berekende minimale lading",
  "settings.photovoltaics.settings.soc_actual.help": "Deze waarde wordt automatisch berekend op basis van de huidige staat. Het wordt beheerd door automatische laadregeling op basis van het jaarlijkse seizoen, of door handmatige instelling van de minimale lading met DS en zonder DS. Als de waarde 100% is, dan is het laden van de batterij verboden, bijvoorbeeld op basis van spotverhandeling.",
  "settings.photovoltaics.settings.soc_grid": "Minimale oplaadniveau met DS",
  "settings.photovoltaics.settings.soc_grid.help": "Met deze waarde kunt u het minimale oplaadniveau van de batterij in % SOC regelen wanneer de distributienetwerk beschikbaar is. In Solax in de Backup modus is het minimale oplaadniveau van de batterij 15%.",
  "settings.photovoltaics.settings.temp": "Minimale lading met net",
  "settings.photovoltaics.settings.temp.help": "Met deze waarde kunt u de minimale lading van de batterij in % SOC regelen wanneer de",
  "settings.photovoltaics.settings.temp_ek": "Minimale oplaadniveau zonder net",
  "settings.photovoltaics.settings.temp_ek.help": "Met deze waarde kunt u het minimale oplaadniveau van de batterij in % SOC regelen wanneer de",
  "settings.photovoltaics.unbalanced_enabled": "Asymmetrie van de fotovoltaïsche omvormer",
  "settings.photovoltaics.unbalanced_enabled.subtitle": "Informatie over de asymmetrie van de fotovoltaïsche omvormer.",
  "settings.photovoltaics_auto_settings": "Automatische laadregeling",
  "settings.photovoltaics_auto_settings.subtitle": "Automatische minimale SOC-regeling op basis van de jaarlijkse periode",
  "settings.plug": "Aansluitingen",
  "settings.plug.Led": "Permanente achtergrondverlichting",
  "settings.plug.Led-batt": "Achtergrondverlichting wanneer de batterij wordt opgeladen",
  "settings.plug.Led-batt.subtitle": "Achtergrondverlichting actief als de batterij ten minste 95% is",
  "settings.plug.Led-over": "Achtergrondverlichting tijdens overloop",
  "settings.plug.enabled": "Geïnstalleerde stopcontacten",
  "settings.plug.enabled.subtitle": "Aansluitingen op het lokale netwerk",
  "settings.plug.enabled2": "Tweede stopcontact",
  "settings.plug.enabled3": "Derde stopcontact",
  "settings.plug.ip1": "Het IP-adres van de eerste socket",
  "settings.plug.ip1.label": "IP 3",
  "settings.plug.ip2": "Het IP-adres van de tweede socket",
  "settings.plug.ip2.label": "IP 2",
  "settings.plug.ip3": "Het IP-adres van de derde socket",
  "settings.plug.ip3.label": "IP 3",
  "settings.plug.modulenabled": "Sockets op de module",
  "settings.plug.modulip": "IP-adres van de module",
  "settings.plug.modulip.label": "IP-module",
  "settings.plug.name1": "Naam van socket 1",
  "settings.plug.name1.label": "Naam",
  "settings.plug.name2": "Naam van socket 2",
  "settings.plug.name2_label": "Naam",
  "settings.plug.name3": "Naam van socket 3",
  "settings.plug.name3.label": "Naam",
  "settings.plug.statusLed": "Signaaldiode",
  "settings.readability_mode.default": "Standaard",
  "settings.readability_mode.large": "Groot",
  "settings.relay": "Relais",
  "settings.relay.0.enabled": "Eerste relais",
  "settings.relay.1.enabled": "Tweede relais",
  "settings.relay.1.type": "Voorwaarde",
  "settings.relay.1.type.HDO": "Spiegel HDO",
  "settings.relay.1.type.batteryfull": "Batterij meer dan 95% opgeladen",
  "settings.relay.1.type.batterylow": "Batterij minder dan minimaal ingesteld opgeladen",
  "settings.relay.1.type.bojlerFull": "Boiler is bijna opgewarmd",
  "settings.relay.1.type.none": "Niet gebruikt",
  "settings.relay.1.type.plug1": "Aansluiting 1",
  "settings.relay.1.type.plug2": "Aansluiting 2",
  "settings.relay.1.type.plug3": "Aansluiting 3",
  "settings.relay.1.type.spotHi": "Hoge spotprijs",
  "settings.relay.1.type.spotLow": "Lage spotprijs",
  "settings.relay.1.type.spotMi": "Gemiddelde spotprijs",
  "settings.relay.1.type.spotNegative": "Negatieve spotprijs",
  "settings.relay.1.type.thermostat1": "Thermostaatcircuit 1",
  "settings.relay.1.type.thermostat2": "Thermostaatcircuit 2",
  "settings.relay.1.type.thermostat3": "Thermostaatcircuit 3",
  "settings.relay.1.type.thermostat4": "Thermostaatcircuit 4",
  "settings.relay.2.enabled": "Derde relais",
  "settings.relay.3.enabled": "Vierde relais",
  "settings.relay.above_price_relay": "Spotprijs voor activering van het relais",
  "settings.relay.above_price_relay.subtitle": "Als de spotprijs hoger is dan deze waarde, wordt het relais ingeschakeld. Als deze lager is, wordt het relais uitgeschakeld.",
  "settings.relay.above_price_relay_15m": "Spotprijs voor activering van het relais (15 min)",
  "settings.relay.above_price_relay_15m.subtitle": "Als de spotprijs hoger is dan deze waarde, wordt het relais ingeschakeld. Als deze lager is, wordt het relais uitgeschakeld.",
  "settings.relay.above_soc_relay": "Batterijlading voor het activeren van het relais",
  "settings.relay.above_soc_relay.subtitle": "Als de batterijlading hoger is dan deze waarde, wordt het relais ingeschakeld.",
  "settings.relay.above_soc_relay_hyst": "Hysterese van de SOC van de batterij voor het uitschakelen van het relais",
  "settings.relay.above_soc_relay_hyst.subtitle": "Als de batterijlading met deze waarde onder de ingestelde activeringswaarde daalt, wordt het relais uitgeschakeld.",
  "settings.relay.below_price_relay": "Spotprijs voor het activeren van het relais",
  "settings.relay.below_price_relay.subtitle": "Als de spotprijs lager is dan deze waarde, wordt het relais ingeschakeld. Als deze hoger is, wordt het relais uitgeschakeld.",
  "settings.relay.below_price_relay_15m": "Spotprijs voor activering van het relais (15 min)",
  "settings.relay.below_price_relay_15m.subtitle": "Als de spotprijs lager is dan deze waarde, wordt het relais ingeschakeld. Als deze hoger is, wordt het relais uitgeschakeld.",
  "settings.relay.below_soc_relay": "Batterijlading voor het activeren van het relais",
  "settings.relay.below_soc_relay.subtitle": "Als de batterijlading met deze waarde onder de ingestelde activeringswaarde daalt, wordt het relais uitgeschakeld.",
  "settings.relay.below_soc_relay_hyst": "Hysterese van de SOC van de batterij voor het uitschakelen van het relais",
  "settings.relay.below_soc_relay_hyst.subtitle": "Als de batterijlading met deze waarde boven de ingestelde activeringswaarde stijgt, wordt het relais uitgeschakeld.",
  "settings.relay.enabled": "Geïnstalleerde relais",
  "settings.relay.enabled.subtitle": "Geïntegreerde relais",
  "settings.relay.item.enabled": "Relais {index}",
  "settings.relay.item.name": "Naam relais",
  "settings.relay.item.status": "Status",
  "settings.relay.option": "Voorwaarde",
  "settings.relay.temp_above_relay.subtitle": "Als de keteltemperatuur hoger is dan deze waarde, wordt het relais ingeschakeld.",
  "settings.relay.temp_above_relay_hyst.subtitle": "Als de keteltemperatuur met deze waarde onder de ingestelde activeringswaarde daalt, schakelt het relais uit.",
  "settings.relay.temp_below_relay.subtitle": "Als de keteltemperatuur lager is dan deze waarde, schakelt het relais in.",
  "settings.relay.temp_below_relay_hyst": "Hysterese van de keteltemperatuur in °C voor het uitschakelen van het relais",
  "settings.relay.temp_below_relay_hyst.subtitle": "Als de keteltemperatuur met deze waarde boven de ingestelde activeringswaarde stijgt, schakelt het relais uit",
  "settings.relay.temp_relay": "Boiler temperatuur voor het relais om te activeren",
  "settings.relay.temp_relay_hyst": "Hysterese van de keteltemperatuur °C voor het uitschakelen van het relais",
  "settings.relay.type.Active": "Permanent ingeschakeld",
  "settings.relay.type.HDO": "Spiegel HDO",
  "settings.relay.type.batteryBelowSOC": "Batterijlading onder de ingestelde SOC",
  "settings.relay.type.batteryDischarge": "Batterij ontlaadt naar het net",
  "settings.relay.type.batteryFull": "Batterijlading boven de ingestelde SOC",
  "settings.relay.type.batteryLow": "Batterijlading onder het ingestelde minimum",
  "settings.relay.type.bojlerFull": "De boiler is bijna opgewarmd",
  "settings.relay.type.hdo": "Spiegel HDO",
  "settings.relay.type.heatWaterAboveTemp": "Boiler is boven de ingestelde temperatuur verwarmd",
  "settings.relay.type.heatWaterBelowTemp": "Boiler is onder de ingestelde temperatuur verwarmd",
  "settings.relay.type.heatWaterMaxTemp": "Boiler is bijna opgewarmd",
  "settings.relay.type.heatWaterTemp": "Boiler is boven de ingestelde temperatuur verwarmd",
  "settings.relay.type.none": "Niet gebruikt, permanent uitgeschakeld",
  "settings.relay.type.plug1": "Aansluiting 1",
  "settings.relay.type.plug2": "Aansluiting 2",
  "settings.relay.type.plug3": "Aansluiting 3",
  "settings.relay.type.plug4": "Aansluiting 4",
  "settings.relay.type.spotBatteryDischarge": "Batterij ontlaadt naar het net",
  "settings.relay.type.spotHi": "Hoge spotprijs",
  "settings.relay.type.spotHi15M": "Hoge spotprijs (15 min)",
  "settings.relay.type.spotLow": "Lage spotprijs",
  "settings.relay.type.spotLow15M": "Lage spotprijs (15 min)",
  "settings.relay.type.spotMi": "Gemiddelde spotprijs",
  "settings.relay.type.spotMi15M": "Gemiddelde spotprijs (15 min)",
  "settings.relay.type.spotNegative": "Beperking van terug leveren naar het netwerk",
  "settings.relay.type.spotNegative15M": "Verbod op teruglevering naar het netwerk (15 min)",
  "settings.relay.type.spotPriceAbove": "Spotprijs boven de ingestelde waarde",
  "settings.relay.type.spotPriceAbove15M": "Spotprijs boven de ingestelde waarde (15 min)",
  "settings.relay.type.spotPriceBelow": "Spotprijs onder de ingestelde waarde",
  "settings.relay.type.spotPriceBelow15M": "Spotprijs onder de ingestelde waarde (15 min)",
  "settings.relay.type.spotStopAccumulation": "Accumulatie gestopt, actieve verkoop",
  "settings.relay.type.stopAccumulation": "Accumulatie gestopt, actieve verkoop",
  "settings.relay.type.thermostat1": "Thermostaat 1",
  "settings.relay.type.thermostat2": "Thermostaat 2",
  "settings.relay.type.thermostat3": "Thermostaat 3",
  "settings.relay.type.thermostat4": "Thermostaat 4",
  "settings.relay.user_advanced_control": "Pagina met informatie voor de gebruiker weergeven",
  "settings.relay.user_advanced_control.subtitle": "Wanneer ingeschakeld, verschijnt er een pagina in de navigatie",
  "settings.service": "Service",
  "settings.service.connection_type": "Verbinding",
  "settings.service.customer": "Gebruikersnaam",
  "settings.service.customer-email": "E-mailadres van gebruiker",
  "settings.service.customer-email-subtitle": "Als de gebruiker geen account heeft onder dit e-mailadres, wordt er automatisch een account aangemaakt en wordt er een registratiemail verzonden.",
  "settings.service.customer-email.label": "E-mail",
  "settings.service.customer-subtitle": "Wordt gebruikt om de installatie voor het bedrijf en de klant te identificeren",
  "settings.service.customer.label": "Naam",
  "settings.service.exit": "Uitloggen bij de dienst",
  "settings.service.exit.button": "Uitloggen",
  "settings.service.info": "Installatie",
  "settings.service.inverter_type": "Type omvormer",
  "settings.service.inverter_type.label": "Omvormer",
  "settings.service.modbus_tcp": "LAN/WiFi",
  "settings.service.network": "Netwerk",
  "settings.service.network.help.content": "De lijst toont apparaten die momenteel zijn aangesloten op het Infigy-netwerk (WiFi of kabel), hun IP-adressen, MAC-adressen, enz. Als een apparaat DHCP gebruikt, kunt u op de pin klikken om het IP-adres vast te leggen dat de DHCP- server altijd zal toewijzen. Dit is handig voor apparaten zoals omvormers, warmtepompen, enz.",
  "settings.service.network.help.title": "Netwerkinstellingen",
  "settings.service.network.mac": "MAC-adres",
  "settings.service.network.online.internet": "Toegang tot internet",
  "settings.service.network.online.internet.help": "Toegang tot internet is vereist voor externe toegang, systeemupdates, spotprijzen en andere functies. Voor volledige functionaliteit moeten alle drie de indicatoren groen zijn.{br}{br}De eerste indicator toont de beschikbaarheid van internet (ping 8.8.8.8).{br}{br}De tweede indicator toont de beschikbaarheid van internet inclusief DNS (ping infigy.cz).{br}{br}De derde indicator toont de toegang tot de interne cloudservices van Infigy (beschikbaarheid van VPN).{br}{br}Als er een probleem is met de verbinding, controleer de kabel of neem contact op met de netwerkbeheerder, als de lokale netwerk beperkingen heeft op communicatie naar internet.{br}{br}{wikiLink}",
  "settings.service.network.online.internet.help.wikiLink": "Meer informatie in onze wiki.",
  "settings.service.network.online.portal": "Toegang tot het Infigy-portaal",
  "settings.service.network.wan": "WAN-adres",
  "settings.service.network.wifi_passphrase": "Wifi-netwerkwachtwoord",
  "settings.service.network_type": "Netwerk",
  "settings.service.network_type.custom": "Handmatige adresinstelling",
  "settings.service.network_type.external": "Lokaal netwerk (klant)",
  "settings.service.network_type.internal": "Intern Infigy-netwerk",
  "settings.service.password": "Toegang tot service",
  "settings.service.password.label": "Wachtwoord",
  "settings.service.relay": "Relais",
  "settings.service.reset": "Fout hersteld",
  "settings.service.reset.button": "Fout herstellen",
  "settings.service.rs485": "RS485",
  "settings.service.service-email": "E-mailadres servicebedrijf",
  "settings.service.service-email-subtitle": "Om het apparaat te koppelen aan het installatieaccount, moet u het e-mailadres van het servicebedrijf invoeren e-mailadres van het servicebedrijf invoeren, dat is opgeslagen in het gedeelte Partner van de applicatie.",
  "settings.service.service-email.label": "E-mail",
  "settings.service.servicer": "Naam van de installateur",
  "settings.service.servicer.label": "Naam",
  "settings.service.solidsun_op": "SolidSun OP",
  "settings.service.solidsun_op.label": "SolidSun OP",
  "settings.service.spot": "Spothandel",
  "settings.service.tester.label": "Naam van tester",
  "settings.service.thermostat": "Thermostaat",
  "settings.service.town": "Locatie (dorp)",
  "settings.service.version": "Versie van de applicatie",
  "settings.service.wallbox_type": "Type wallbox",
  "settings.service.wallbox_type.label": "Wallbox",
  "settings.spot": "Spot handel",
  "settings.spot.battery": "Batterij opladen per spot toegestaan",
  "settings.spot.battery.stop_discharge_auto": "Automatische ontladingsbeperking",
  "settings.spot.battery.stop_discharge_auto.help": "Als u deze optie selecteert, regelt het systeem automatisch de ontlading van de accu en staat het alleen bij de hoogste dagelijkse spotprijzen.",
  "settings.spot.battery.stop_discharge_auto.subtitle": "Automatische controle van de opslag van energie tegen de hoogste prijs",
  "settings.spot.battery.stop_discharge_hi_price": "Batterijontlading bij lage en gemiddelde prijzen verbieden",
  "settings.spot.battery.stop_discharge_high_price": "Ontlading van de batterij bij lage en gemiddelde prijzen verbieden",
  "settings.spot.battery.stop_discharge_high_price.help": "Als u deze optie selecteert, zal het systeem geen energie uit de batterij gebruiken bij lage en gemiddelde spotprijzen. Het systeem zal de batterij niet ontladen. Deze zal worden gebruikt bij hogere prijzen.",
  "settings.spot.battery.stop_discharge_low_price": "Batterijontlading bij lage prijzen verbieden",
  "settings.spot.battery.stop_discharge_low_price.help": "Als u deze optie selecteert, zal het systeem geen energie uit de batterij gebruiken bij lage spotprijzen. Het systeem zal de batterij niet ontladen. Deze zal worden gebruikt bij hogere prijzen (gemiddelde en hoge prijs).",
  "settings.spot.battery.stop_discharge_low_price.subtitle": "Beheer van de opslag van energie bij gemiddelde en hoge prijzen",
  "settings.spot.battery.stop_discharge_middle_price.subtitle": "Beheer van de opslag van energie bij hoge prijzen",
  "settings.spot.batteryAllOverflowPrice": "Minimumprijs voor het ontladen van de volledige batterijcapaciteit",
  "settings.spot.batteryOverflow": "Batterijontlading naar het net toestaan volgens spotprijzen",
  "settings.spot.batteryOverflowPrice": "Minimumprijs voor het ontladen van de batterij",
  "settings.spot.batterySale": "Toegestaan ontladen van batterij naar het net volgens spotprijzen",
  "settings.spot.battery_all_overflow_price": "Minimumprijs voor het ontladen van de volledige batterijcapaciteit",
  "settings.spot.battery_all_overflow_price.help": "Als de spotprijs hoger is dan deze waarde, wordt de batterijcapaciteit op het gunstigste moment naar het net ontladen tot het ingestelde minimale SOC. Dit betekent dat er geen energie in de batterij wordt opgeslagen voor nachtverbruik. Na ontlaad van de batterij naar het net wordt energie voor het object gekocht van het net",
  "settings.spot.battery_all_overflow_price.subtitle": "De energie wordt opgeslagen in de batterij voor dagelijks verbruik",
  "settings.spot.battery_charge": "Toegestaan opladen van de batterij per spot",
  "settings.spot.battery_charge.help": "Als u deze optie selecteert, plant het systeem het opladen tegen de laagste prijzen. Het houdt rekening met het huidige laadniveau van de batterij en de capaciteit ervan. Op basis van deze parameters de oplaadtijd om de batterij tegen de laagst mogelijke prijs op te laden.",
  "settings.spot.battery_charge.subtitle": "Het regelen van de batterij op basis van spotprijzen verhoogt de afschrijving van de batterij",
  "settings.spot.battery_max_soc": "Eind-SOC van de batterij",
  "settings.spot.battery_max_soc.subtitle": "Maximale lading van de batterij bij het opladen via het elektriciteitsnet",
  "settings.spot.battery_overflow": "Batterijontlading naar het elektriciteitsnet toestaan op basis van spotprijzen",
  "settings.spot.battery_overflow.help": "Als u deze optie selecteert, plant het systeem het ontladen van de batterij naar het elektriciteitsnet tegen de hoogste dagprijs en wordt alleen de energie ontladen die niet nodig is voor het dagelijkse verbruik van het object. Met de onderstaande parameters kunt u de prijs bepalen voor het ontladen van de volledige batterijcapaciteit en het ontladen alleen het deel van de batterijcapaciteit dat niet nodig is voor het nachtverbruik.",
  "settings.spot.battery_overflow.subtitle": "Maakt het mogelijk om de overtollige energie in de batterij op het gunstigste moment naar het net te ontladen",
  "settings.spot.battery_overflow_price": "Minimumprijs voor het ontladen van de batterij",
  "settings.spot.battery_overflow_price.help": "Als de spotprijs hoger is dan deze waarde, wordt alleen de overtollige batterijcapaciteit naar het net ontladen. Dit betekent dat er energie in de batterij wordt opgeslagen voor nachtverbruik van het object. Er wordt dus geen energie van het net gekocht",
  "settings.spot.battery_overflow_price.subtitle": "De energie wordt opgeslagen in de batterij voor nachtverbruik",
  "settings.spot.battery_strategy": "Strategie voor spotladen van de batterij",
  "settings.spot.battery_strategy.help": "Met deze schuifregelaar kunt u eenvoudig de voorkeur voor het gebruik van de batterij bij spot trading instellen. Lagere waarden (vanaf 20 %) betekenen minder batterijcycli en dus minder frequent laden/ontladen. volgens spotprijzen. Hogere waarden (tot 70 %) betekenen het tegenovergestelde.",
  "settings.spot.battery_strategy_service.subtitle": "Met deze optie kunnen eindgebruikers de batterijstrategie instellen op het tabblad Spot",
  "settings.spot.battery_strategy_user": "De gebruiker toestaan de batterijstrategie in te stellen",
  "settings.spot.battery_strategy_user.subtitle": "Met deze optie kunt u eindgebruikers toestaan de batterijstrategie in te stellen op het tabblad Spot.",
  "settings.spot.install": "Spot-handel actief",
  "settings.spot.latitude": "Breedtegraad",
  "settings.spot.latitude.mess": "Breedte",
  "settings.spot.longitude": "Lengtegraad",
  "settings.spot.longitude.mess": "Lengte",
  "settings.spot.min_difference_price_charge_from_grid": "Minimaal verschil in spotprijs voor het opladen van de batterij vanuit het elektriciteitsnet",
  "settings.spot.min_difference_price_charge_from_grid.help": "Met deze parameter kunt u het opladen van de batterij vanaf de spot regelen bij een laag verschil tussen de laagste en hoogste prijs. Als de parameter 2 CZK is en het verschil tussen de hoogste prijs (3 CZK) en de laagste prijs (1 CZK) van de spot lager is, dan wordt de batterij opgeladen",
  "settings.spot.min_difference_price_charge_from_grid.subtitle": "Minimaal verschil in spotprijs gedurende de dag, om de batterij op te laden vanuit het elektriciteitsnet",
  "settings.spot.overflow": "Optimalisatie van overloop op basis van spotprijzen toestaan",
  "settings.spot.overflow.help": "Als u deze optie selecteert, geeft het systeem voorrang aan overloop naar het net boven het opladen van de batterij bij",
  "settings.spot.overflow.subtitle": "Maakt het mogelijk om overloop voor prioriteit te geven voor accumulatie",
  "settings.spot.overflow_offset": "Maximale overloop bij negatieve prijs",
  "settings.spot.overflow_offset.help": "De waarde geeft de overloop naar het distributienetwerk bij een negatieve prijs aan. We raden aan deze functie te gebruiken in het geval van een energiegemeenschap.",
  "settings.spot.overflow_offset.subtitle": "De waarde kan niet hoger worden ingesteld dan de maximale overloop",
  "settings.spot.price.period": "Tijdsperiode",
  "settings.spot.price_above_price": "Prijs van het netstroom bij hoog tarief per kWh. Deze prijs wordt opgeteld bij de spotprijs als het hoge tarief van kracht is. De HDO-tijden moeten worden ingesteld voor een correcte berekening van de prijs in het hoge en laag tarief. Dit bedrag staat vermeld op de elektriciteitsrekening.",
  "settings.spot.price_below": "Prijs van het netstroomtarief bij laag tarief per kWh. Deze prijs wordt opgeteld bij de spotprijs als het lage tarief actief is. De HDO-tijden moeten worden ingesteld voor een correcte berekening van de prijs in het hoge en laag tarief. Dit bedrag staat vermeld op de elektriciteitsrekening.",
  "settings.spot.price_distribution_hi": "Prijs van het netstroomtarief bij hoog tarief",
  "settings.spot.price_distribution_hi.help": "Prijs van het netstroomtarief bij hoog tarief",
  "settings.spot.price_distribution_low": "Prijs van het netstroomtarief bij laag tarief",
  "settings.spot.price_distribution_low.help": "Prijs van het netstroomtarief bij laag tarief",
  "settings.spot.price_offset": "De prijs voor het verbieden van terug leveren",
  "settings.spot.price_offset.help": "Wij raden aan om ten minste de commissie/vergoeding van de handelaar voor de verkoop van stroomoverschotten in te stellen op de minimale spotprijs, waaronder de verkoop van overschotten verboden is.",
  "settings.spot.price_offset.subtitle": "De waarde wordt vergeleken met de dagelijkse marktprijs zonder het distributietarief.",
  "settings.spot.region": "Regio",
  "settings.thermostat.hp-blocked": "Blokkering van de warmtepomp",
  "settings.thermostat.hysteresis": "Temperatuurhysterese",
  "settings.thermostat.install": "Thermostaat actief",
  "settings.thermostat.name.label": "Naam",
  "settings.thermostat.name1": "Naam thermostaat 1",
  "settings.thermostat.name2": "Naam thermostaat 2",
  "settings.thermostat.name3": "Naam thermostaat 3",
  "settings.thermostat.name4": "Naam thermostaat 4",
  "settings.thermostat.nominal": "Nominaal vermogen van de bron",
  "settings.thermostat.number-of-thermostat": "Aantal thermostaten",
  "settings.utility": "Huisparameters",
  "settings.utility.loadpercent": "Huidige stroomonderbrekerbelasting",
  "settings.utility.numberofphase": "Driefasige installatie",
  "settings.utility.settings.ampers": "Grootte van de stroomonderbreker",
  "settings.utility.settings.loadpercent": "Bij overschrijding wordt het verbruik beperkt",
  "settings.utility.settings.loadpercent_max": "Bij overschrijding wordt het verbruik beperkt",
  "settings.wallbox": "Wallboxen",
  "settings.wallbox.install": "Wallbox actief",
  "settings.wallbox.name": "Naam van de wallbox {number}",
  "settings.wallbox.spot": "Wallboxen",
  "settings.wallbox.type": "Type wallbox",
  "shellies.list": "Shellies",
  "shellies.mqtt_broker_running": "MQTT Broker-status",
  "shellies.settings": "Instellingen",
  "shellies.settings.boiler.active": "Boiler aangesloten via Shellies",
  "shellies.settings.boiler.id": "ID van Shellies",
  "shellies.settings.boiler.id.label": "ID",
  "shellies.title": "Shellies",
  "spot.chartview": "Prijs weergeven zonder distributiekosten",
  "spot.draft": "Modi voor vandaag",
  "spot.draft.actualpricehi": "De huidige prijs is hoog, verminder het verbruik",
  "spot.draft.actualpricelow": "De huidige prijs is laag, verhoog het verbruik",
  "spot.draft.hesLevel": "Niveau van HES-controle",
  "spot.draft.hiprice": "Limieten van verminderd verbruik",
  "spot.draft.info": "Modi en aanbevelingen voor vandaag",
  "spot.draft.lowprice": "De limiet van verhoogd verbruik",
  "spot.draft.todaystatus_HP": "Accumulatie van warmtepomp",
  "spot.draft.todaystatus_HW": "Accumulatie van warmwater",
  "spot.draft.todaystatus_bat": "Accumulatie van batterijen",
  "spot.draft.todaystatus_em": "Overloop",
  "spot.explanation": "Uitleg van modi",
  "spot.explanation.battery_discharge_to_grid": "Batterij ontladen naar het net",
  "spot.explanation.battery_discharge_to_home": "Batterij ontladen",
  "spot.explanation.hw": "Batterij opladen van het net",
  "spot.explanation.info": "Uitleg van modi voor vandaag",
  "spot.flexibility": "Flexibiliteitsschatting voor vandaag",
  "spot.prediction": "Schatting van het verbruik voor vandaag",
  "spot.prediction.bat": "Dispositionele batterijaccumulatie",
  "spot.prediction.battery": "Dispositionele batterijaccumulatie",
  "spot.prediction.home": "Normaal verbruik van het huis",
  "spot.prediction.hp": "Warmtepomp",
  "spot.prediction.hw": "Dispositionele warmwateraccumulatie",
  "spot.prediction.pv": "Productie van fotovoltaïsche energie",
  "spot.prediction.sale": "Energie voor verkoop",
  "spot.prediction.sale.help": "Resterende geplande dagelijkse overloop, die prioriteit krijgt als overloop naar het net vóór de batterij",
  "spot.price.period.15min": "15 min",
  "spot.price.period.60min": "60 min",
  "spot.region.cz": "CZ",
  "spot.region.nl": "NL",
  "spot.region.sk": "SK",
  "spot.status": "Spothandel",
  "spot.summary.battery_charge_from_grid": "Opladen via het elektriciteitsnet",
  "spot.summary.battery_charge_from_grid.help": "Het opladen van de accu via het elektriciteitsnet volgens de spotprijs kan in de instellingen worden in- of uitgeschakeld. Het systeem plant het opladen van de accu tijdens periodes met lage prijzen, rekening houdend met het huidige accuniveau niveau en capaciteit. Op basis van deze parameters bepaalt het de oplaadtijd om",
  "spot.summary.battery_discharge": "Batterij ontladen",
  "spot.summary.battery_discharge.help": "Het ontladen van de batterij naar het huis volgens de spotprijs kan worden in- of uitgeschakeld in de instellingen. Ontladen wordt meestal uitgeschakeld tijdens periodes met lage prijzen, wanneer het beter is om energie uit het net te gebruiken en de batterij te sparen voor periodes met hogere prijzen.",
  "spot.summary.battery_discharge_to_grid": "Ontladen naar het elektriciteitsnet",
  "spot.summary.battery_discharge_to_grid.help": "Het ontladen van de batterij naar het elektriciteitsnet kan worden ingeschakeld of uitgeschakeld in de instellingen. Het systeem plant het ontladen van de batterij naar het net tijdens de hoogste dagelijkse prijzen, waarbij alleen de energie wordt ontladen die niet nodig is voor het normale verbruik van het huis.",
  "spot.summary.boiler": "Boiler",
  "spot.summary.boiler.help": "Het systeem plant de verwarming van de boiler tijdens lage prijzen, rekening houdend met de huidige watertemperatuur temperatuur, de capaciteit van de boiler en de gewenste temperatuur. Op basis van deze parameters bepaalt het",
  "spot.summary.heat_pump": "Warmtepomp",
  "spot.summary.heat_pump.help": "De warmtepomp kan in drie modi werken: verhoogde prestaties, normaal bedrijf en verminderde prestaties. Verhoogde prestaties worden gebruikt tijdens lage prijzen, normaal bedrijf tijdens gemiddelde prijzen en verminderde prestaties tijdens hoge prijzen. Vertraging of toename van het verbruik kan",
  "spot.summary.heat_pump_level.increase": "Verhoogde prestaties",
  "spot.summary.heat_pump_level.normal": "Normaal bedrijf",
  "spot.summary.heat_pump_level.reduction": "Verminderde prestaties",
  "spot.summary.price": "Prijs",
  "spot.summary.price_buy": "Prijs met distributie",
  "spot.summary.price_distribution": "Distributie",
  "spot.summary.price_level": "Prijsniveau",
  "spot.summary.price_level.help": "Infigy sorteert de spotprijzen per uur van laag naar hoog en verdeelt ze in drie ongeveer gelijke delen. Als de uurtarieven variëren van 3 CZK tot 10 CZK, kan het lage prijsbereik 3-6 CZK zijn, het gemiddelde 6-7 CZK en het hoge 7-10 CZK. Het bereik zal dagelijks variëren, afhankelijk van de frequentie van",
  "spot.summary.price_level.hi": "Hoge prijs",
  "spot.summary.price_level.low": "Lage prijs",
  "spot.summary.price_level.mid": "Gemiddelde prijs",
  "spot.summary.price_level_15m": "Prijsniveau 15m",
  "spot.summary.price_sell": "Prijs zonder distributie",
  "spot.summary.spotOverflow": "Overloop naar het netwerk",
  "spot.summary.spotOverflow.allowed": "Toegestaan",
  "spot.summary.spotOverflow.help": "Door overloop naar het net toe te staan tijdens spot trading wordt de spotprijs in een bepaald uur vergeleken en als deze deze lager is dan de prijs voor het verbieden van overloop volgens de instellingen, dan zal het systeem automatisch",
  "spot.summary.spotOverflow.restricted": "Beperkt",
  "spot.summary.state.active": "Actief",
  "spot.summary.state.inactive": "Inactief",
  "spot.summary.time": "Tijd",
  "spot.user.parameters": "Parameters van spot-handel",
  "spot_wizard.banner.button": "Wil je hulp? Ik kan je helpen",
  "spot_wizard.banner.subtitle": "De handleiding helpt je bij het instellen van spot trading.",
  "spot_wizard.banner.title": "Wil je hulp? Ik kan je helpen",
  "spot_wizard.battery_discharge.paragraph1": "Dit instellen verbiedt het ontladen van de batterij bij lage spotprijzen. Dit houdt energie over voor hogere prijzen tijdens de dag.",
  "spot_wizard.battery_discharge.paragraph2": "Als je alleen energie verkoopt op de spot, kun je de verbod deactiveren.",
  "spot_wizard.battery_discharge.title": "Ontladen van de batterij naar je eigen verbruik",
  "spot_wizard.battery_purchase.paragraph1": "Dit instellen maakt het opladen van de batterij vanaf de laagste spotprijs mogelijk wanneer de productie laag is.",
  "spot_wizard.battery_purchase.paragraph2": "Let op de strategie-instelling. Als je 20% instelt, zal Infigy voornamelijk wachten op fotovoltaïsche energie. Anders zal Infigy voornamelijk kopen op de spot. We raden aan om 25% in te stellen.",
  "spot_wizard.battery_purchase.paragraph3": "Als je alleen energie verkoopt op de spot, kun je het opladen deactiveren.",
  "spot_wizard.battery_purchase.title": "Kopen van energie in de batterij",
  "spot_wizard.boiler.paragraph1": "Dit instellen maakt het verwarmen van de boiler vanaf de laagste prijzen tijdens de dag naar de ingestelde temperatuur mogelijk. Infigy houdt de basis temperatuur bij en gebruikt de toename in temperatuur van de spot.",
  "spot_wizard.boiler.paragraph2": "Het is ook mogelijk om de verwarming te blokkeren bij middel of hoge prijzen.",
  "spot_wizard.boiler.paragraph3": "Als je alleen energie verkoopt op de spot, kun je de temperatuur instellen op 10°C en de verwarming blokkeren.",
  "spot_wizard.boiler.title": "Verwarmen van de boiler",
  "spot_wizard.dialog.finish": "Voltooien",
  "spot_wizard.dialog.next": "Volgende",
  "spot_wizard.dialog.prev": "Vorige",
  "spot_wizard.dialog.step": "Stap {current} van {total}",
  "spot_wizard.dialog.title": "Handleiding voor het instellen van spot trading",
  "spot_wizard.distribution_prices.title": "Voer de prijs in voor distributie in laag en hoog prijsbereiken",
  "spot_wizard.done.description": "Je hebt het instellen van spot trading voltooid. Alle parameters kunnen worden bewerkt in de onderste delen van de Spot pagina, waar je ook deze handleiding opnieuw kunt aanroepen.",
  "spot_wizard.done.title": "Voltooid",
  "spot_wizard.evening_peak_discharge.paragraph1": "Infigy schat automatisch het verbruik van energie in de ochtenduren. Het overschot kan worden verkocht tegen de hoogste prijs van de dag.",
  "spot_wizard.evening_peak_discharge.paragraph2": "Als je alleen energie kunt kopen op de spot, kun je het ontladen deactiveren.",
  "spot_wizard.evening_peak_discharge.title": "Ontladen van de batterij in de avondpiek",
  "spot_wizard.general_settings.title": "Eerste algemene instellingen",
  "spot_wizard.hdo_times.title": "Instellen van HDO-tijden bepaalt het laag prijsbereik",
  "spot_wizard.heat_pump.paragraph1": "Dit instellen maakt het verhogen van de prestaties van de warmtepomp bij laag productie en het verlagen van de prestaties bij hoge prijzen mogelijk.",
  "spot_wizard.heat_pump.paragraph2": "Als je alleen energie verkoopt op de spot, kun je de vertraging en toename van het verbruik deactiveren.",
  "spot_wizard.heat_pump.title": "Warmtepomp",
  "spot_wizard.info.button1": "Waarom is mijn batterij niet vanaf de spot vandaag geladen?",
  "spot_wizard.info.button2": "Waarom is mijn batterij niet naar de spot vandaag ontladen?",
  "spot_wizard.info.button3": "Ik heb hulp nodig bij het instellen",
  "spot_wizard.info.help1.title": "Waarom is mijn batterij niet vanaf de spot vandaag geladen?",
  "spot_wizard.info.help2.title": "Waarom is mijn batterij niet naar de spot vandaag ontladen?",
  "spot_wizard.info.title": "Informatie over spot trading",
  "spot_wizard.overflow_limit.paragraph1": "Als je alleen energie kunt kopen op de spot, kun je -10 Kč instellen. Overstroming is beperkt tot de maximale grootte die is ingesteld door de service technicus.",
  "spot_wizard.overflow_limit.paragraph2": "Als je ook energie kunt verkopen op de spot, is het voordelig om de accumulatie te stoppen bij een prijs die overeenkomt met de commissie van je leverancier. De commissie is meestal 0.30 - 0.70 EUR/kWh.",
  "spot_wizard.overflow_limit.title": "Beperking van overstroming naar het net",
  "spot_wizard.preferential_sale.paragraph1": "Deze functie stelt terugleverprioriteit in tijdens de ochtendpiek. Energie wordt bij voorkeur aan het net verkocht in plaats van opgeslagen in de batterij, boiler en warmtepomp. Accumulatie wordt opnieuw geactiveerd bij lage prijzen of na verkoop van het geschatte energie-overschot.",
  "spot_wizard.preferential_sale.paragraph2": "Als je alleen energie kunt kopen op de spot, kun je de functie deactiveren.",
  "spot_wizard.preferential_sale.title": "Voordelige verkoop van energie",
  "statistics.battery.statistics": "Niveau van de batterijlaad",
  "statistics.boiler.statistics": "Boilerverwarming met een elektrisch verwarmingselement",
  "statistics.electrical_grid.statistics": "Aankoop van het net",
  "statistics.electrical_grid.statistics_house_consumption": "Verbruik van het object",
  "statistics.electrical_grid.statistics_overflow": "Overloop naar een net",
  "statistics.heatpump.statistics": "Compressorverbruik",
  "statistics.outdoor_temperature.statistics": "Buitentemperatuur",
  "statistics.photovoltaics.statistics": "Productie van fotovoltaïsche energie",
  "statistics.plug.statistics": "Verbruik van stopcontacten",
  "statistics.wind.statistics": "Productie van windturbines",
  "stats_delete.button": "Verwijderen",
  "stats_delete.cancel": "Annuleren",
  "stats_delete.confirm": "Verwijderen",
  "stats_delete.confirm.title": "Wilt u echt alle statistieken verwijderen?",
  "stats_delete.title": "Alle statistieken verwijderen",
  "stats_export.button": "Exporteren",
  "stats_export.from": "Van",
  "stats_export.metric": "Meting",
  "stats_export.title": "Statistieken exporteren",
  "stats_export.to": "Naar",
  "status.heatWater.flexibility": "Flexibiliteit actief, verwarming van warm water",
  "status.heatWater.heating": "Verwarming van warm water",
  "status.heatWater.hwError": "De boiler is volledig verwarmd of niet beschikbaar",
  "status.heatWater.inverterError": "Voorverwarming is inactief, de omvormer is niet beschikbaar",
  "status.heatWater.legionella": "Waterzuivering, legionella",
  "status.heatWater.notConnected": "Kan geen verbinding tot stand brengen",
  "status.heatWater.notLicensed": "Boilerregeling heeft geen licentie",
  "status.heatWater.off": "Uit",
  "status.heatWater.overload": "Overbelasting van het netwerk, verwarming gestopt",
  "status.heatWater.pvHeating": "Verwarming door overbelasting",
  "status.heatWater.smartMeterError": "Voorverwarming van de boiler is inactief, de elektriciteitsmeter is niet beschikbaar",
  "status.heatWater.spotHeating": "Verwarming van warm water vanaf de plek",
  "status.heatWater.stop": "Stop",
  "status.heatWater.stopHDO": "Verwarming geblokkeerd bij hoge prijs",
  "status.heatWater.stopSOC": "Verwarming geblokkeerd, laag batterijniveau",
  "status.heatWater.stopSell": "Voorverwarming geblokkeerd, verkoop van energie",
  "status.heatWater.tempError": "Temperatuursensor is niet beschikbaar",
  "status.photovoltaic.dischargeBlockedByComponents": "Ontladen van batterij gepauzeerd vanwege verbruik van geselecteerde technologieën",
  "status.photovoltaic.dischargeBlockedByHDO": "Ontladen van batterij gepauzeerd, hoog tarief actief (HDO)",
  "status.photovoltaic.discharging": "Ontladen van de batterij",
  "status.photovoltaic.distributionLimit": "Distributie beperkt vermogen",
  "status.photovoltaic.feedInPriority": "Prioriteit voor teruglevering aan het net",
  "status.photovoltaic.flexibilityBatteryStop": "Flexibiliteit actief, opladen en ontladen van de batterij gestopt",
  "status.photovoltaic.flexibilityCharging": "Flexibiliteit actief, opladen van de batterij via het netwerk",
  "status.photovoltaic.flexibilityDischarging": "Flexibiliteit actief, ontladen van de batterij naar het netwerk",
  "status.photovoltaic.flexibilityDoNotDischarge": "Flexibiliteit actief, verbod op ontladen van de batterij",
  "status.photovoltaic.flexibilityFeedInPriority": "Flexibiliteit actief, prioriteit van overstroming naar het netwerk",
  "status.photovoltaic.flexibilityOverflowRestricted": "Flexibiliteit actief, verbod op overstroming naar het netwerk",
  "status.photovoltaic.forcedOverflow": "Flexibiliteit actief, gedwongen overstroming naar het netwerk",
  "status.photovoltaic.idle": "Stand-by modus",
  "status.photovoltaic.manualCharging": "Handmatig opladen van de batterij",
  "status.photovoltaic.manualDischarging": "Handmatig ontladen van de batterij",
  "status.photovoltaic.noOverflowLimit": "Geen overlooplimiet",
  "status.photovoltaic.noneInverter": "Omvormertype niet ingesteld",
  "status.photovoltaic.notConnected": "Kan geen verbinding tot stand brengen",
  "status.photovoltaic.notLicensed": "FVE-besturing heeft geen licentie",
  "status.photovoltaic.planCharge": "Geplande lading van de accu",
  "status.photovoltaic.planDischarge": "Geplande ontlading van de batterij",
  "status.photovoltaic.production": "Productie van energie",
  "status.photovoltaic.sellBatteryEnergy": "Verkoop van energie uit de batterij",
  "status.photovoltaic.spotCharging": "Opladen van de batterij ter plaatse",
  "status.photovoltaic.spotStopDischarging": "Ontladen gestopt, lage prijs ter plaatse",
  "status.photovoltaic.standby": "Stand-by modus",
  "status.photovoltaic.startUp": "Opstartmodus",
  "status.plug.batteryControl": "Stopcontact actief volgens batterij",
  "status.plug.manualControl": "Aansluiting actief in handmatige modus",
  "status.plug.notActive": "Aansluiting inactief",
  "status.plug.notConnected": "Kan geen verbinding tot stand brengen",
  "status.plug.overflowControl": "Aansluiting actief volgens overloop",
  "status.plug.spotControl": "Aansluiting actief volgens spot",
  "status.plug.stop": "Stop",
  "status.plug.timeControl": "Aansluiting actief volgens tijdstip",
  "status.smartMeter.consumption": "Normaal verbruik van het huis",
  "status.smartMeter.maxLoad": "Maximaal verbruik van het huis",
  "status.smartMeter.none": "",
  "status.smartMeter.overflow": "Overstroom van energie naar het net",
  "status.smartMeter.overflowLimited": "Overstroom beperkt vanwege negatieve prijs",
  "status.smartMeter.shortage": "Tekort van het distributienetwerk",
  "status.spotBattery.flexibilityPV": "Flexibiliteit gebruikt voor PV",
  "status.spotBattery.flexibilitySpot": "Flexibiliteit gebruikt voor SPOT",
  "status.spotBattery.noData": "Geen gegevens voor controle",
  "status.spotBattery.spotNotLicensed": "Spot heeft geen vergunning",
  "status.spotBatteryChargeFromGrid.batteryChargingNotActive": "Opladen van de batterij van het net is inactief",
  "status.spotBatteryChargeFromGrid.batteryChargingPlanned": "Opladen van de batterij van het net is actief",
  "status.spotBatteryChargeFromGrid.enoughPVEnergy": "Vandaag wordt verwacht dat er een overvloed is voor het opladen van de batterij",
  "status.spotBatteryChargeFromGrid.priceDifferenceTooLow": "Vandaag is de minimale prijsverschil niet bereikt",
  "status.spotBatteryChargeFromGrid.spotNotActive": "Spothandel is inactief",
  "status.spotBatteryDischargeToGrid.batteryDischargingNotActive": "Batterij ontladen naar het net is inactief",
  "status.spotBatteryDischargeToGrid.batteryDischargingPlanned": "Batterij ontladen naar het net is actief",
  "status.spotBatteryDischargeToGrid.minPriceNotReached": "Vandaag is de minimale prijs voor verkoop niet bereikt",
  "status.spotBatteryDischargeToGrid.notEnoughBatteryEnergy": "Vandaag wordt verwacht dat er een tekort is aan energie voor de eigen verbruik",
  "status.spotBatteryDischargeToGrid.spotNotActive": "Spothandel is inactief",
  "status.spotBatteryDischargeToHome.automaticDischargeMode": "Batterij ontladen volgens capaciteit",
  "status.spotBatteryDischargeToHome.highPriceDischargeMode": "Batterij ontladen bij hoge prijs",
  "status.spotBatteryDischargeToHome.mediumAndHighPriceDischargeMode": "Batterij ontladen bij gemiddelde en hoge prijs",
  "status.spotBatteryDischargeToHome.notControlled": "Batterij ontladen is niet beperkt",
  "status.spotHeatPump.flexibilityPV": "Flexibiliteit gebruikt voor PV",
  "status.spotHeatPump.flexibilitySpot": "Flexibiliteit gebruikt voor SPOT",
  "status.spotHeatPump.noData": "Geen gegevens voor controle",
  "status.spotHeatPump.spotNotLicensed": "Spot heeft geen licentie",
  "status.spotHeatWater.flexibilityPV": "Flexibiliteit gebruikt voor PV",
  "status.spotHeatWater.flexibilitySpot": "Flexibiliteit gebruikt voor SPOT",
  "status.spotHeatWater.noData": "Geen gegevens voor controle",
  "status.spotHeatWater.spotNotLicensed": "Spot heeft geen licentie",
  "status.spotSmartMeter.noData": "Geen gegevens voor controle",
  "status.spotSmartMeter.overflowDisabled": "Permanente overloopbeperking",
  "status.spotSmartMeter.overflowFlexibilitySell": "Optimalisatie van overloop voor verkoop",
  "status.spotSmartMeter.overflowLimited": "Overloop beperkt vanwege negatieve prijs",
  "status.spotSmartMeter.spotNotLicensed": "Spot heeft geen licentie",
  "status.spotSmartMeter.withoutReduction": "Zonder beperking",
  "status.wind.production": "Energie produceren",
  "status.wind.stop": "STOP",
  "status.wind.unavailable": "Niet beschikbaar",
  "subscriptions.fetch": "Abonnement bijwerken",
  "subscriptions.fetch.button": "Abonnement bijwerken",
  "subscriptions.last_fetch_at": "Laatste update",
  "subscriptions.premium_active": "Premium actief",
  "subscriptions.title": "Abonnement",
  "test-product.app": "Applicatie",
  "test-product.settings": "Instellingen",
  "test-product.settings.distribution": "Distributie",
  "test-product.settings.distribution.Dzd": "DZD",
  "test-product.settings.distribution.Infigy": "Infigy",
  "test-product.settings.distribution.solid_sun": "SolidSun",
  "test-product.settings.license": "Licentie",
  "test-product.settings.license.HW": "HW",
  "test-product.settings.license.Industrial": "Industrial",
  "test-product.settings.license.Play": "PLAY",
  "test-product.settings.license.Smart": "Smart",
  "test-product.settings.license.basic": "Basis",
  "test-product.test": "Apparaattest",
  "test-product.test.DC": "Controle van het gelijkstroomcircuit",
  "test-product.test.DC.subtitle": "Aansluiten van de aansluitingen, kabelafmetingen",
  "test-product.test.component": "Onderdeleninspectie",
  "test-product.test.component.subtitle": "Is er een sensor, labels, ...?",
  "test-product.test.electricmeter": "Controle van de smartmeter",
  "test-product.test.electricmeter.subtitle": "Controle van de installatie van de smartmeter voor de omvormer",
  "test-product.test.internet-connect": "Internetverbinding",
  "test-product.test.inverter-connect": "De omvormer aansluiten",
  "test-product.test.license": "Licentie",
  "test-product.test.license-info": "Licentie",
  "test-product.test.phase_1": "Fase 1-test",
  "test-product.test.phase_2": "Fase 2-test",
  "test-product.test.phase_3": "Fase 3-test",
  "test-product.test.serialNumber": "Serienummer van het apparaat",
  "test-product.test.serialNumber.label": "Serienummer",
  "test-product.test.serialNumber.subtitle": "Zonder serienummer kunnen de naam van de tester en de test niet worden ingevoerd",
  "test-product.test.serialNumberSwitchboard": "Productienummer van de kast",
  "test-product.test.serialNumberSwitchboard.label": "Serienummer",
  "test-product.test.serialNumberSwitchboard.subtitle": "Invullen als het apparaat zich in de originele kast bevindt",
  "test-product.test.start": "Als het apparaat is aangesloten",
  "test-product.test.start.button": "Activeer de test",
  "test-product.test.switchboard": "Controle van de conformiteit van de kast",
  "test-product.test.switchboard.subtitle": "Controleer de aansluiting van de aansluitklemmen, de plaatsing van de componenten en de juiste kabel",
  "test-product.test.temp": "Temperatuursensor",
  "test-product.test.tester": "Apparaat getest door",
  "test-product.test.tester.subtitle": "Zonder naam kan de test niet worden geactiveerd",
  "thermostat.general": "Algemene instellingen",
  "thermostat.general.cooling": "Koeling actief",
  "thermostat.general.cooling.pvstability": "Potentieel van de bron",
  "thermostat.general.heating": "Verwarming actief",
  "thermostat.range": "Thermostaat",
  "thermostat.range.flexibility-temperature": "Flexibele temperatuur",
  "thermostat.range.flexibility-temperature.subtitle": "Temperatuur waarmee het huis kan worden voorverwarmd of voorgekoeld",
  "thermostat.range.flexibility_status": "Flexibele modus van de thermostaat",
  "thermostat.range.on": "Thermostaat actief",
  "thermostat.range.on.subtitle": "Basistemperatuur",
  "thermostat.range.pv-flexibility": "Regeling door fotovoltaïsche energie",
  "thermostat.range.set_temperature": "Ingestelde temperatuur",
  "thermostat.range.sp-flexibility-down": "Verbruik uitstellen op basis van spotprijs",
  "thermostat.range.sp-flexibility-up": "Verbruik verhogen volgens spotprijs",
  "thermostat.range.status": "Flexibele modus thermostaat",
  "thermostat.range.temperature": "Ingestelde temperatuur",
  "thermostat.statisticsTemp": "Thermostaattemperatuur",
  "thermostat.status": "Thermostaatmodus",
  "wallbox.3a.on": "Modus 3A",
  "wallbox.3a.on_sub": "Het opladen kan 3A uit het distributienetwerk halen",
  "wallbox.6a.on": "Modus 6A",
  "wallbox.6a.on_sub": "Alleen opladen via fotovoltaïsche energie",
  "wallbox.NO_CHARGE": "Niet opladen",
  "wallbox.NO_CHARGE.on_sub": "Opladen is permanent geblokkeerd; alleen een schema kan het starten",
  "wallbox.PV": "Opladen volgens batterij",
  "wallbox.PV.batteryStart": "Inschakelen wanneer volledig opgeladen",
  "wallbox.PV.batteryStart.subtitle": "Begin met opladen wanneer de batterij wordt opgeladen",
  "wallbox.PV.batteryStop": "Uitschakelen wanneer volledig opgeladen",
  "wallbox.PV.batteryStop.subtitle": "Stop met opladen wanneer de batterij wordt opgeladen",
  "wallbox.PV.on": "Actief",
  "wallbox.PV.on_sub": "Nadat de basisenergie is bereikt, wordt er alleen opgeladen wanneer de batterij volledig is opgeladen",
  "wallbox.PV2": "Opladen volgens PV",
  "wallbox.PV2.on": "Actief",
  "wallbox.PV2.on_sub": "Laadcontrole op basis van PV-prestaties",
  "wallbox.PV_FAST": "Prioriteit opladen volgens batterij",
  "wallbox.PV_FAST.batteryMinSoc": "Minimale batterijreserve",
  "wallbox.PV_FAST.batteryMinSoc.subtitle": "De batterij wordt voor het opladen van de auto niet onder deze waarde ontladen. Totdat deze waarde is overschreden, wacht het opladen",
  "wallbox.PV_FAST.on_sub": "Het opladen van de auto heeft volledige prioriteit. Alleen energie van de batterij of PV wordt gebruikt",
  "wallbox.SPOT": "Opladen op basis van spotprijzen",
  "wallbox.SPOT.hi": "Voorkom opladen tegen hoge prijzen",
  "wallbox.SPOT.mi": "Opladen tegen gemiddelde prijzen voorkomen",
  "wallbox.SPOT.on": "Actief",
  "wallbox.SPOT.on_sub": "Na het bereiken van de basisenergie zal er blokkering optreden tijdens hoge spotprijzen",
  "wallbox.active": "{name}",
  "wallbox.active.subtitle": "Actief",
  "wallbox.alfen": "Alfen",
  "wallbox.authorization.status": "Autorisatie",
  "wallbox.authorization.status.authorized": "Geautoriseerd{cardInfo}",
  "wallbox.authorization.status.denied": "Afgewezen{cardInfo}",
  "wallbox.authorization.status.pending": "Niet geautoriseerd",
  "wallbox.authorization.status.unknown": "Onbekende status",
  "wallbox.az_router": "AZ Router",
  "wallbox.common": "Algemene informatie",
  "wallbox.common.power": "Huidig verbruik",
  "wallbox.common.power_today": "Huidig verbruik",
  "wallbox.common.power_total": "Totaal verbruik",
  "wallbox.common.power_year": "Jaarlijks verbruik",
  "wallbox.control": "Laadmodus",
  "wallbox.ecovolter": "EcoVolter",
  "wallbox.evmate": "EVmate",
  "wallbox.fast-charge": "Snel opladen",
  "wallbox.fast-charge.energy": "Energie voor snel opladen",
  "wallbox.fast-charge.energy_actual": "Opgeladen energie in de huidige cyclus",
  "wallbox.fast-charge.energy_sub": "Energie die altijd zo snel mogelijk wordt opgeladen. Nadat deze waarde is bereikt, wordt het opladen",
  "wallbox.goodwe-ev-charger": "Goodwe",
  "wallbox.inactive.subtitle": "Inactief",
  "wallbox.mode.pv.batteryStopConflict.description": "Wanneer de accu blokkering is ingeschakeld bij wallbox gebruik, kan de modus „Accu opladen“ niet worden ingeschakeld. Schakel de blokkering uit en stel een andere wallbox modus in.",
  "wallbox.mode.pv.batteryStopConflict.title": "Modus kan niet worden ingeschakeld",
  "wallbox.mybox": "MyBox",
  "wallbox.none": "Geen",
  "wallbox.nonemode": "Normaal opladen",
  "wallbox.nonemode.amper-auto": "Automatische regeling van de laadstroom",
  "wallbox.nonemode.amper-auto.subtitle": "Regelt het opladen om het opladen en ontladen van de batterij te minimaliseren",
  "wallbox.nonemode.ampers": "Maximale laadstroom",
  "wallbox.nonemode.hdo": "Alleen opladen tegen laag tarief",
  "wallbox.nonemode.hdo_sub": "De HDO-tijden moeten worden ingesteld in de algemene instellingen",
  "wallbox.nonemode.on": "Actief",
  "wallbox.nonemode.on_sub": "De auto laadt zo snel mogelijk op",
  "wallbox.olife": "Olife",
  "wallbox.other": "Andere",
  "wallbox.pv.ampers-auto": "Gewenste laadstroom",
  "wallbox.schedules.description": "Plan het opladen van de elektrische auto naar behoefte.",
  "wallbox.schedules.title": "Oplaadplanner",
  "wallbox.settings": "Instellingen",
  "wallbox.solax": "Solax - communicatie via omvormer",
  "wallbox.solax-ev-charger": "Solax - communicatie via Infigy",
  "wallbox.statistics": "Statistieken",
  "wallbox.status": "Wallbox modus",
  "wallbox.status.car_not_connected": "Auto niet aangesloten",
  "wallbox.status.charging": "Opladen",
  "wallbox.status.charging_with_ventilation": "Opladen met ventilatie",
  "wallbox.status.error": "Fout",
  "wallbox.status.home": "Wallbox modus",
  "wallbox.status.normal": "Normaal",
  "wallbox.status.not_connected": "Kan geen verbinding maken",
  "wallbox.status.off": "Wallbox uit",
  "wallbox.status.ready": "Klaar om op te laden",
  "wallbox.sub_status.auto": "volgens auto. modus",
  "wallbox.sub_status.basic_energy": "basisenergie",
  "wallbox.sub_status.battery": "volgens batterij",
  "wallbox.sub_status.battery_fast": "prioriteit volgens batterij",
  "wallbox.sub_status.battery_waiting": ", wacht op batterijlading",
  "wallbox.sub_status.hdo_block": ", HDO-blok",
  "wallbox.sub_status.no_charging": ", opladen is uitgeschakeld",
  "wallbox.sub_status.none": "",
  "wallbox.sub_status.photovoltaics": "volgens FVE",
  "wallbox.sub_status.schedule": "volgens planner",
  "wallbox.sub_status.spot": "volgens SPOT",
  "wallbox.sub_status.spot_high": ", hoge SPOT-prijs",
  "wallbox.sub_status.spot_mid": ", gemiddelde SPOT-prijs",
  "wallbox.victron-ev-charger": "Victron EV-lader",
  "wallbox.wallboxes.title": "Wallboxen",
  "wallbox_rfid.add_button": "RFID-kaart toevoegen",
  "wallbox_rfid.delete.cancel": "Annuleren",
  "wallbox_rfid.delete.confirm": "Verwijderen",
  "wallbox_rfid.delete.confirm.title": "Kaart {name} verwijderen?",
  "wallbox_rfid.dialog.already_exists": "Kaart {id} is al opgeslagen onder de naam {name}.",
  "wallbox_rfid.dialog.already_exists_hint": "Plaats een andere kaart of sluit het dialoogvenster.",
  "wallbox_rfid.dialog.cancel": "Annuleren",
  "wallbox_rfid.dialog.name_label": "Naam van de kaart",
  "wallbox_rfid.dialog.save": "Opslaan",
  "wallbox_rfid.dialog.scanned_id": "Kaart-ID: {id}",
  "wallbox_rfid.dialog.title": "RFID-kaart toevoegen",
  "wallbox_rfid.dialog.waiting": "Plaats de kaart op de lezer…",
  "wallbox_rfid.edit.dialog.title": "RFID-kaart bewerken",
  "wallbox_wizard.cancel": "Annuleren",
  "wallbox_wizard.custom_device_ip_address.alert": "Zorg ervoor dat het IP-adres van de wallbox niet verandert (bijvoorbeeld wanneer de wallbox een DHCP)",
  "wallbox_wizard.custom_device_ip_address.input": "IP-adres van de wallbox",
  "wallbox_wizard.multiple_wallboxes.alert": "Voor meerdere wallboxen, neem contact op met de supportline. Contact kan worden gevonden in de technische wiki Infigy.",
  "wallbox_wizard.multiple_wallboxes.label": "Meerdere wallboxen",
  "wallbox_wizard.open": "Wallbox configureren",
  "wallbox_wizard.save": "Opslaan",
  "wallbox_wizard.title": "Wallbox-configuratie",
  "welcome.subtitle": "Toepassingen voor huishoudelijke en moderne energie op één plek!",
  "welcome.title": "Welkom bij Infigy!",
  "wifi_ap_config.interface_block.confirm.confirmation_text": "{blocked, select, true {Block} other {Unblock}}",
  "wifi_ap_config.interface_block.confirm.content": "Wilt u echt {blocked, select, true {block} other {unblock}} wifi?",
  "wifi_ap_config.interface_block.confirm.title": "WiFi-status wijzigen",
  "wifi_ap_config.passphrase_change.confirm.passphrase": "Wachtwoord",
  "wifi_ap_config.passphrase_change.confirm.title": "WiFi-wachtwoord wijzigen",
  "wifi_ap_config.wifi_interface_blocked.button": "{blocked, select, true {Unblock} other {Block}}",
  "wifi_ap_config.wifi_interface_blocked.title": "WiFi-status",
  "wifi_ap_config.wifi_interface_blocked.value": "{blocked, select, true {Blocked} other {Active}}",
  "wind.common": "Algemene informatie",
  "wind.common.battery_charged_total": "Totaal vermogen naar batterij",
  "wind.common.battery_current": "Batterijstroom",
  "wind.common.battery_power": "Batterijvermogen",
  "wind.common.battery_voltage": "Batterijspanning",
  "wind.common.load_current": "Belastingsstroom",
  "wind.common.power": "Huidig windvermogen",
  "wind.common.power_today": "De productie van vandaag",
  "wind.common.power_total": "Totale productie",
  "wind.common.power_year": "Jaarlijkse productie",
  "wind.common.resistor_power": "Belastingsstroom",
  "wind.statistics": "Statistieken",
  "wind.statistics.battery_charge_power": "Batterijvermogen",
  "wind.statistics.load_current": "Belastingsstroom",
  "wind.statistics.power": "Vermogen windturbine",
  "wind.statistics.wind_speed": "Windsnelheid",
  "wind.status": "Windturbinemodus"
}